window.addEventListener("DOMContentLoaded", () => {
  /**
   * Global animations
   */

  // Gestion du scroll pour .sticky dans .vehicle_aside_details
  let lastScrollTop = 0;
  const scrollThreshold = 5;
  const $stickyElement = $(".sticky");

  $(window).on("scroll", function () {
    const currentScrollTop = $(window).scrollTop();

    // Retirer toutes les classes si on est tout en haut de la page
    if (currentScrollTop <= 0) {
      $stickyElement.removeClass("scrollup");
      lastScrollTop = currentScrollTop;
      return;
    }

    // Calculer la différence de scroll
    const scrollDifference = Math.abs(currentScrollTop - lastScrollTop);

    // Ne réagir que si le scroll dépasse le seuil
    if (scrollDifference < scrollThreshold) {
      return;
    }

    // Scroll vers le bas
    if (currentScrollTop > lastScrollTop) {
      // Retirer la classe scrollup
      if (currentScrollTop >= 100) {
        $stickyElement.removeClass("scrollup");
      }
    }
    // Scroll vers le haut - afficher le sticky
    else if (currentScrollTop >= 100) {
      $stickyElement.addClass("scrollup");
    }

    lastScrollTop = currentScrollTop;
  });

  // .buttons_filters_wrapper est collante (position: sticky; top: 0). On ajoute
  // l'ombre (.is_sticky) uniquement quand elle est réellement collée en haut,
  // c.-à-d. quand son bord haut atteint le haut du viewport (top <= 0).
  // NB : on ne peut pas fiabiliser ça via IntersectionObserver ici — la barre est
  // en width:100vw et déborde de la largeur de la scrollbar, donc son
  // intersectionRatio n'atteint jamais 1 (l'ombre resterait affichée en continu).
  const $buttonsFiltersWrapper = document.querySelector(
    ".buttons_filters_wrapper",
  );
  if ($buttonsFiltersWrapper) {
    const toggleFiltersShadow = () => {
      $buttonsFiltersWrapper.classList.toggle(
        "is_sticky",
        $buttonsFiltersWrapper.getBoundingClientRect().top <= 0,
      );
    };
    toggleFiltersShadow();
    window.addEventListener("scroll", toggleFiltersShadow, { passive: true });
  }

  // si le navigateur a la fonctionnalité de partage
  if (navigator.share) {
    $(".share").on("click", function () {
      navigator.share({
        title: document.title,
        text: document.title,
        url: window.location.href,
      });
    });
  }

  // Au click sur .ellipsis, on affiche/cache les liens
  $("#breadcrumb .ellipsis").on("click", function () {
    $("#breadcrumb .breadcrumb-item--middle").addClass("active");
    $(this).hide();
    // on cache aussi le svg frere qui suit directement cela
    $(this).next("svg").hide();
  });

  // Au click sur le bouton download, ouvrir l'impression
  $(".action_item.download").on("click", function () {
    window.print();
  });

  // Animation text dans les boutons
  $(".btn.text_effect").click(function (e) {
    if (window.innerWidth > 768) {
      // ne pas suivre le href
      e.preventDefault();
      $(this).toggleClass("active");
    }
  });

  // Au click sur le bouton qui ont le data-action="call-advisor", en vanilla, avec debounce
  document.querySelectorAll('[data-action="begin-checkout"]').forEach((button) => {
    button.addEventListener(
      "click",
      debounce(() => {
        const productId = button.dataset.productId;
        const actionOrigin = button.dataset.actionOrigin;
        const dataLayerParams = forgeAddToCartDataLayer(productId, actionOrigin);
        pushDataLayer(dataLayerParams);
      }, 1000),
    );
  });

  // Animation show more/less pour les blocs de texte avec classe .truncate (géré par le web component text-truncate)
  // Code conservé uniquement pour compatibilité avec les anciennes implémentations manuelles
  $(".show_truncate").on("click", function () {
    const textBlock = $(this).prev(".text_block");
    const showMore = $(this).data("show-more");
    const showLess = $(this).data("show-less");

    if (textBlock.hasClass("truncate")) {
      textBlock.removeClass("truncate");
      $(this).text(showLess);
    } else {
      // Le texte est étendu, on le tronque
      textBlock.addClass("truncate");
      $(this).text(showMore);
    }
  });

  // Au click sur .show_hidden_content, on affiche/cache le texte
  $(document).on("click", ".show_hidden_content", function () {
    $(this).text($(this).text() === "Voir plus" ? "Voir moins" : "Voir plus");
    $(this).prev("p").slideToggle(150);
  });

  /**
   * Formulaires
   */

  // Boutons de filtrage rapide
  // Au click sur un bouton .quick_filter, on clique sur l'input correspondant dans filters-form
  $(document).on("click", ".buttons_filters_wrapper .quick_filter", function (e) {
    e.preventDefault();

    const filterValue = $(this).attr("data-filter-id");
    if (!filterValue) return;

    // Trouver l'input dans filters-form avec la même valeur
    const $filtersForm = $("filters-form");
    const $targetInput = $filtersForm.find(`input[type="checkbox"][id="${filterValue}"]`);

    if ($targetInput.length > 0) {
      // Cliquer sur l'input pour déclencher tous les événements associés
      $targetInput.click();

      // Si l'input est une checkbox on ajoute ou retire la class active a this si la checkbox est checked
      if ($targetInput.prop("checked")) {
        $(this).addClass("active");
      } else {
        $(this).removeClass("active");
      }
    }
  });

  // Input toggle
  // Au click sur .input_toggle, on simule un click sur l'input pour déclencher le comportement natif
  $(document).on("click", ".input_toggle", function (e) {
    const $input = $(this).find("input");

    // Si on clique directement sur l'input ou le label, laisser le comportement natif
    if ($(e.target).is("input") || $(e.target).is("label")) {
      return;
    }

    // Si on clique ailleurs (sur le toggle par exemple), simuler un click sur l'input
    // Cela va déclencher le comportement natif + les événements change/input
    e.preventDefault();
    e.stopPropagation();
    $input[0].click();

    if ($input.attr("id") === "compare_toggle") {
      const isChecked = $input.prop("checked");
      const $vehicleCards = $(".product_card");

      if (isChecked) {
        // Mode comparaison activé
        $vehicleCards.addClass("compare");
      } else {
        // Mode comparaison désactivé
        $vehicleCards.removeClass("compare");
        $(".comparison_wrapper").removeClass("active");
        // on vide le comparateur
        if (window.ComparisonManager) {
          window.ComparisonManager.clearVehicles();
        }
        // Retirer la classe active de tous les compare_wrapper
        $(".compare_wrapper").removeClass("active");
      }

      // Si on est en mobile, on scroll vers .vehicles_list
      if (isChecked) {
        // Ajouter un timeout de 100ms
        setTimeout(function () {
          if ($(".products_list_wrapper").length > 0) {
            $("html, body").animate(
              {
                scrollTop: $(".buttons_filters_wrapper").offset().top,
              },
              1000,
            );
          } else if ($(".favorites_list").length > 0) {
            $("html, body").animate(
              {
                scrollTop: $(".favorites_list").offset().top,
              },
              1000,
            );
          }
        }, 100);
      }
    }
  });

  //Si l'input dans un label a une valeur, on ajoute la classe active au label
  $(document).on("blur", "input", function () {
    if ($(this).val()) {
      $(this).closest("label").addClass("active");
    } else {
      $(this).closest("label").removeClass("active");
    }
  });

  /**
   * Footer
   */
  if ($(window).width() < 769) {
    $(document).on("click", ".menu_item > p", function () {
      $(this).parent(".menu_item").toggleClass("open");
      $(this).next("nav").slideToggle();
    });
  }

  /**
   * Gestion des accordeons
   */
  $(".accordeon_title").on("click", function () {
    $(this).toggleClass("active");
    $(this).next(".accordeon_content").slideToggle();
  });

  // Lightbox
  $(".main_slider .extend, .main_slider .swiper-slide").click(function () {
    removeScroll();
    $("#lightbox").addClass("active");
    // Synchroniser avec le slide actuel du main slider
    var currentIndex = mainSwiper.realIndex;
    lightboxSwiper.slideToLoop(currentIndex, 0);
  });

  // fermeture de la lightbox au click de .action_item.close dans .lightbox_container
  $(document).on("click", ".lightbox_container .action_item.close", function () {
    $("#lightbox").removeClass("active");
    $("body").css("padding-right", "").removeClass("no-scroll");
  });

  /**
   * Gestion des sliders
   */
  var thumbSwiper = new Swiper(".thumb_swiper", {
    direction: "vertical",
    mousewheel: true,
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 8,
    watchSlidesProgress: true,
    navigation: {
      disabledClass: "swiper-button-disabled",
      nextEl: ".thumb-swiper-next",
      prevEl: ".thumb-swiper-prev",
    },
    on: {
      beforeInit: function (swiper) {
        // On clone les slides trois fois
        var slides_html = $(".thumb_swiper .swiper-wrapper").html();
        for (let i = 0; i < 3; i++) {
          $(".thumb_swiper .swiper-wrapper").append(slides_html);
        }
      },

      slideChangeTransitionEnd: function () {
        if (!isUpdating) {
          var realIndex = this.realIndex;
          syncSliders(thumbSwiper, realIndex);
        }
      },
    },
  });

  // Main slider fiche véhicule
  var mainSwiper = new Swiper(".main_slider", {
    loop: true,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".main-swiper-next",
      prevEl: ".main-swiper-prev",
    },
    thumbs: {
      swiper: thumbSwiper,
    },
    on: {
      beforeInit: function (swiper) {
        // On clone les slides trois fois
        var slides_html = $(".main_slider .swiper-wrapper").html();
        for (let i = 0; i < 3; i++) {
          $(".main_slider .swiper-wrapper").append(slides_html);
        }
      },
      slideChangeTransitionEnd: () => {
        // Gestion de l'événement interaction_gallery
        pushDataLayer({ event: "interaction_gallery" });
      },
    },
  });

  // Slider lightbox (sera initialisé dynamiquement)
  var lightboxSwiper = new Swiper(".lightbox_slider", {
    spaceBetween: 10,
    loop: true,
    pagination: {
      el: ".lightbox-swiper-pagination",
      type: "custom",
      renderCustom: function (swiper, current, total) {
        return current + " sur " + total;
      },
    },
    navigation: {
      nextEl: ".lightbox-swiper-next",
      prevEl: ".lightbox-swiper-prev",
    },
    on: {
      beforeInit: function (swiper) {
        // On clone les slides trois fois
        var slides_html = $(".lightbox_slider .swiper-wrapper").html();
        for (let i = 0; i < 3; i++) {
          $(".lightbox_slider .swiper-wrapper").append(slides_html);
        }
      },
      slideChangeTransitionEnd: function () {
        if (!isUpdating) {
          var realIndex = this.realIndex;
          syncSliders(lightboxSwiper, realIndex);
        }

        // Gestion de l'événement interaction_gallery
        pushDataLayer({ event: "interaction_gallery" });
      },
    },
  });

  // Synchronisation des sliders
  var isUpdating = false;

  // Fonction pour synchroniser les sliders
  function syncSliders(activeSlider, targetIndex) {
    if (isUpdating) return;
    isUpdating = true;

    // Synchroniser mainSwiper
    // if (activeSlider !== mainSwiper) {
    //   mainSwiper.slideToLoop(targetIndex, 300);
    // }

    // Synchroniser thumbSwiper (avec loop)
    if (activeSlider !== thumbSwiper) {
      thumbSwiper.slideToLoop(targetIndex, 300);
    }

    // Synchroniser lightboxSwiper (seulement s'il existe)
    if (lightboxSwiper && activeSlider !== lightboxSwiper) {
      // Utiliser slideToLoop pour éviter les problèmes de transition
      lightboxSwiper.slideToLoop(targetIndex, 300);
    }

    setTimeout(function () {
      isUpdating = false;
    }, 350);
  }

  // slider listing véhicules en mobile
  function swiperCard() {
    vehiclesList = new Swiper(".slider_product_card", {
      slidesPerView: "auto",
      spaceBetween: 24,
      freeModeSticky: true,
      normalizeSlideIndex: true,
      freeMode: true,
    });
  }

  swiperCard();
  window.addEventListener("resize", swiperCard);

  // Reviews slider
  // var reviewsSwiper = new Swiper(".reviews_slider", {
  //   slidesPerView: "auto",
  //   spaceBetween: 24,
  //   freeMode: true,
  //   navigation: {
  //     nextEl: ".reviews-swiper-next",
  //     prevEl: ".reviews-swiper-prev",
  //   },
  //   responsive: {
  //     768: {
  //       freeMode: false,
  //     },
  //   },
  // });
});

/**
 * @description Debounce a function : Permet de grouper les appels à une fonction pour éviter les appels multiples en trop (cliquer trop vite sur un bouton par exemple)
 * @param {Function} fn - The function to debounce
 * @param {number} wait - The time to wait in milliseconds
 * @returns {Function}
 */
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

/**
 * @description Throttle a function : Permet de limiter le nombre d'appels à une fonction pour éviter les appels multiples en trop (cliquer trop vite sur un bouton par exemple)
 * @param {Function} fn - The function to throttle
 * @param {number} delay - The time to wait in milliseconds
 * @returns {Function}
 */

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

/**
 * @description Push data to the dataLayer
 * @param {Object} data - The data to push to the dataLayer
 */
function pushDataLayer(data) {
  window.dataLayer = window.dataLayer || [];
  // Suffixe "_elixir" sur le nom de nos events (demande de l'agence GTM) afin de
  // les distinguer des events natifs GTM/Didomi. Appliqué une seule fois, au push,
  // donc tous les events poussés via cette fonction en bénéficient automatiquement.
  // NB : les pushes inline qui ne passent pas par ici (preload_data dans
  // layout/theme.liquid, submit_newsletter dans sections/footer.liquid) portent le
  // suffixe directement dans leur littéral.
  if (data && typeof data.event === "string" && !data.event.endsWith("_elixir")) {
    data.event = data.event + "_elixir";
  }
  window.dataLayer.push(data);
}

function forgeAddToCartDataLayer(productId, actionOrigin = "formulaire") {
  const scriptEl = document.querySelector(`script[data-product-json="${productId}"]`);
  if (!scriptEl) return;
  const json_raw_product = JSON.parse(scriptEl.textContent);

  const dataLayerParams = {
    event: "add_to_cart",
    currency: "EUR",
    value: json_raw_product.price,
    add_to_cart_mode: actionOrigin,
    ecommerce: {
      items: [
        {
          index: 1,
          page: 1,
          item_list_name: json_raw_product.main_collection,
          item_id: json_raw_product.sku,
          item_name: json_raw_product.title,
          item_brand: json_raw_product.vendor,
          item_category: json_raw_product.vehicle.status,
          item_category2: json_raw_product.vehicle.vehicle_type,
          item_category3: json_raw_product.vehicle.gearbox_type,
          item_category4: json_raw_product.vehicle.energy,
          price: json_raw_product.price,
          kilometrage: json_raw_product.vehicle.mileage,
          annee: json_raw_product.vehicle.year,
          puissance: json_raw_product.vehicle.power,
          places: json_raw_product.vehicle.nb_seats,
          couchages: json_raw_product.vehicle.nb_beds,
          disponibilite: json_raw_product.availability.label,
          localisation: json_raw_product.office.name,
        },
      ],
    },
  };
  return dataLayerParams;
}

function forgeBeginCheckoutDataLayer(productId, { email = "", phone = "", optin = "false" } = {}) {
  const scriptEl = document.querySelector(`script[data-product-json="${productId}"]`);
  if (!scriptEl) return;
  const json_raw_product = JSON.parse(scriptEl.textContent);

  return {
    event: "begin_checkout",
    currency: "EUR",
    value: json_raw_product.price,
    optin: optin,
    ecommerce: {
      items: [
        {
          index: 1,
          page: 1,
          item_list_name: json_raw_product.main_collection,
          item_id: json_raw_product.sku,
          item_name: json_raw_product.title,
          item_brand: json_raw_product.vendor,
          item_category: json_raw_product.vehicle.status,
          item_category2: json_raw_product.vehicle.vehicle_type,
          item_category3: json_raw_product.vehicle.gearbox_type,
          item_category4: json_raw_product.vehicle.energy,
          price: json_raw_product.price,
          kilometrage: json_raw_product.vehicle.mileage,
          annee: json_raw_product.vehicle.year,
          puissance: json_raw_product.vehicle.power,
          places: json_raw_product.vehicle.nb_seats,
          couchages: json_raw_product.vehicle.nb_beds,
          disponibilite: json_raw_product.availability.label,
          localisation: json_raw_product.office.name,
        },
      ],
    },
    user_data: {
      email: email,
      phone: phone,
    },
  };
}

function forgeGenerateLeadDataLayer({ email = "", phone = "", zipcode = "" } = {}) {
  return {
    event: "generate_lead",
    user_data: {
      email: email,
      phone: phone,
      zipcode: zipcode,
    },
  };
}

/* ==========================================================================
 * Tracking GTM — helpers communs aux events manuels du plan de tracking.
 * Détail : documentations_techniques/plan-tracking-gtm.md
 * ======================================================================== */

/**
 * Récupère le JSON d'un véhicule par son id produit (fiche produit ou carte).
 * @param {string|number} productId
 * @returns {Object|null}
 */
function getVehicleJson(productId) {
  if (!productId) return null;
  const el = document.querySelector(
    `script[data-product-json="${productId}"], script[data-card-json="${productId}"]`,
  );
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

/**
 * Lit le JSON véhicule attaché à une carte produit (élément .product_card).
 * @param {Element} cardEl
 * @returns {Object|null}
 */
function getCardVehicleJson(cardEl) {
  if (!cardEl) return null;
  const el =
    cardEl.querySelector("script[data-card-json]") ||
    cardEl.querySelector("script[data-product-json]");
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

/**
 * Construit un item GA4 à partir d'un JSON véhicule.
 * Mappe les mêmes champs que forgeAddToCartDataLayer / forgeBeginCheckoutDataLayer.
 * @param {Object} json - JSON véhicule (fiche produit ou carte)
 * @param {Object} [extra] - surcharges (index, page, item_list_name, ...)
 * @returns {Object|null}
 */
function forgeVehicleItem(json, extra = {}) {
  if (!json) return null;
  const vehicle = json.vehicle || {};
  const item = {
    item_id: json.sku,
    item_name: json.title,
    item_brand: json.vendor,
    item_category: vehicle.status,
    item_category2: vehicle.vehicle_type,
    item_category3: vehicle.gearbox_type,
    item_category4: vehicle.energy,
    price: json.price,
    kilometrage: vehicle.mileage,
    annee: vehicle.year,
    puissance: vehicle.power,
    places: vehicle.nb_seats,
    couchages: vehicle.nb_beds,
    disponibilite: json.availability ? json.availability.label : undefined,
    localisation: json.office ? json.office.name : undefined,
  };
  return Object.assign(item, extra);
}

/**
 * Pousse un événement form_error (message d'erreur affiché à l'utilisateur).
 * @param {string} message
 */
function pushFormError(message) {
  if (!message) return;
  pushDataLayer({ event: "form_error", error: String(message) });
}

function removeScroll() {
  var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  if (scrollbarWidth > 0) {
    $("body").css("padding-right", scrollbarWidth + "px");
  }
  $("body").addClass("no-scroll");
}

/**
 * Bloque le scroll de la page à l'ouverture d'un drawer ou d'une modale.
 * La largeur de la scrollbar qui disparaît est compensée pour éviter le décalage du contenu.
 */
function lockPageScroll() {
  const body = document.body;
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;

    // Ajouter aussi le padding au header s'il est en mode scrollup
    const headerContainer = document.querySelector(".header_container.scrollup");
    if (headerContainer) {
      headerContainer.style.paddingRight = `${scrollbarWidth}px`;
    }
  }

  body.classList.add("no-scroll");
}

/**
 * Réactive le scroll de la page, sauf si un drawer ou une modale reste ouvert
 * (ex. : drawer ouvert depuis une modale, ou modale ouverte depuis un drawer).
 */
function unlockPageScroll() {
  const hasActiveDrawer = window.drawerManagerInstance && window.drawerManagerInstance.isDrawerOpen();
  const hasActiveModal = document.querySelector(".modal.active") !== null;

  if (hasActiveDrawer || hasActiveModal) {
    return;
  }

  const body = document.body;
  body.classList.remove("no-scroll");
  body.style.paddingRight = "";

  // Retirer aussi le padding du header
  const headerContainer = document.querySelector(".header_container.scrollup");
  if (headerContainer) {
    headerContainer.style.paddingRight = "";
  }
}

class FiltersForm extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnSubmit = debounce((event) => {
      this.submitForm(event);
    }, 800);

    // Ecouteur sur changement formulaire
    const form = this.querySelector("form");
    if (form) {
      // on input de .search on ne fait rien
      form.addEventListener("input", (event) => {
        if (event.target.closest(".search")) {
          return;
        }
        this.debouncedOnSubmit(event);
        this.updateFilterCount();
      });

      // Ecouteur sur change pour les checkboxes/radios (notamment pour les toggles)
      form.addEventListener("change", (event) => {
        if (event.target.closest(".search")) {
          return;
        }
        // Pour les checkboxes et radios, on soumet aussi le formulaire
        if (event.target.type === "checkbox" || event.target.type === "radio") {
          this.debouncedOnSubmit(event);
          this.updateFilterCount();

          // Synchroniser le .quick_filter correspondant à cet input
          const inputId = event.target.id;
          if (inputId) {
            const quickFilter = document.querySelector(`.quick_filter[data-filter-id="${inputId}"]`);
            if (quickFilter) {
              quickFilter.classList.toggle("active", event.target.checked);
            }
          }
        }
      });
    }

    // Gestion de la recherche dans les filtres
    function debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    // Stocker la fonction debounce pour l'utiliser dans les méthodes
    this.debounce = debounce;

    // Initialiser les event listeners pour les filtres
    this.initFilterEventListeners();

    // Ecouteur de clic sur le bouton "Supprimer les filtres" (remise à zéro du formulaire)
    const resetButton = this.querySelector(".filter_drawer_footer_reset");
    if (resetButton) {
      resetButton.addEventListener("click", (event) => {
        this.resetForm(event);
        // supprimer la class active a toous les .quick_filter
        var quickFilters = document.querySelectorAll(".quick_filter");
        quickFilters.forEach((quickFilter) => {
          quickFilter.classList.remove("active");
        });
      });
    }

    // Initialisation des filtres
    this.filterData = [];

    // Initialiser le formatage des prix
    this.initPriceFormatting();

    // Mettre à jour le compteur de filtres actifs au chargement
    this.updateFilterCount();
  }

  connectedCallback() {
    this.initializeFilters();
    // Mettre à jour le compteur après initialisation
    this.updateFilterCount();
  }

  // Initialiser les event listeners pour les champs de recherche et les boutons "show more"
  initFilterEventListeners() {
    // Rechercher dans les filtres - champ de recherche
    const searchInputs = this.querySelectorAll("input[name='search']");

    searchInputs.forEach((searchInput) => {
      // Récupérer le bouton de suppression pour cet input
      const removeBtn = searchInput.parentElement.querySelector(".filter_search_remove");

      // Gérer l'affichage/masquage du bouton de suppression
      searchInput.addEventListener("input", (event) => {
        if (removeBtn) {
          if (event.target.value.length > 0) {
            removeBtn.style.display = "flex";
          } else {
            removeBtn.style.display = "none";
          }
        }
      });

      // Gérer le clic sur le bouton de suppression
      if (removeBtn) {
        removeBtn.addEventListener("click", (e) => {
          e.stopPropagation();
          searchInput.value = "";
          removeBtn.style.display = "none";
          searchInput.focus();

          // Déclencher l'événement input pour réinitialiser le filtrage
          const event = new Event("input", { bubbles: true });
          searchInput.dispatchEvent(event);
        });
      }

      // Gérer le filtrage des résultats
      searchInput.addEventListener(
        "input",
        this.debounce((event) => {
          const searchTerm = event.target.value.toLowerCase().trim();
          const searchInputParent = searchInput.closest(".filter_category");

          if (searchInputParent) {
            const checkboxes = searchInputParent.querySelectorAll(".checkbox_item");
            const emptyState = searchInputParent.querySelector(".filter_empty_state");
            let visibleCount = 0;

            if (searchTerm === "") {
              // Si la recherche est vide, masquer tout sauf les 5 premiers
              checkboxes.forEach((checkbox, index) => {
                if (index < 5) {
                  checkbox.classList.remove("hidden_item");
                  visibleCount++;
                } else {
                  checkbox.classList.add("hidden_item");
                }
              });
              // Masquer l'empty state quand il n'y a pas de recherche
              if (emptyState) {
                emptyState.style.display = "none";
              }
            } else {
              // Si la recherche contient du texte, filtrer normalement
              checkboxes.forEach((checkbox) => {
                const checkboxText = checkbox.textContent.toLowerCase();

                if (checkboxText.includes(searchTerm)) {
                  checkbox.classList.remove("hidden_item");
                  visibleCount++;
                } else {
                  checkbox.classList.add("hidden_item");
                }
              });

              // Afficher ou masquer l'empty state selon les résultats
              if (emptyState) {
                if (visibleCount === 0) {
                  emptyState.style.display = "flex";
                } else {
                  emptyState.style.display = "none";
                }
              }
            }
          }
        }, 200),
      );
    });

    // Ecouteur de clic sur "Afficher plus/moins"
    const showMoreButtons = this.querySelectorAll(".filter_show_more");
    showMoreButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.toggleShowMore(event, button);
      });
    });

    // Ecouteur de clic sur les checkbox_vehicle_wrapper > div
    // Au click sur une div, on toggle la class checked et on déclenche un change event sur l'input
    const checkboxVehicle = this.querySelectorAll(".checkbox_vehicle_wrapper > div");
    checkboxVehicle.forEach((checkbox) => {
      // Empêcher les clics multiples en vérifiant si l'input est disabled
      const input = checkbox.querySelector("input");
      if (input && input.disabled) {
        return; // Ne pas ajouter d'event listener si l'input est disabled
      }

      checkbox.addEventListener("click", (event) => {
        // Ne pas traiter si on clique sur le label (car il gère déjà le checkbox)
        if (event.target.tagName === "LABEL" || event.target.closest("label")) {
          return;
        }

        // Toggle la classe checked
        checkbox.classList.toggle("checked");

        // Trouver l'input et inverser son état
        if (input) {
          input.checked = !input.checked;

          // Déclencher l'événement change pour que le filtrage fonctionne
          const changeEvent = new Event("change", { bubbles: true });
          input.dispatchEvent(changeEvent);
        }
      });
    });
  }

  // Initialiser les filtres : déplacer le toggle wrapper et fermer les collapsibles >= 7
  initializeFilters() {
    // Déplacer le .input_toggle_wrapper dans le collapsible précédent
    const toggleWrapper = this.querySelector(".input_toggle_wrapper");

    if (toggleWrapper) {
      // Trouver le collapsible-content précédent
      let previousCollapsible = toggleWrapper.previousElementSibling;

      // Parcourir les éléments précédents jusqu'à trouver un collapsible-content
      while (previousCollapsible && previousCollapsible.tagName.toLowerCase() !== "collapsible-content") {
        previousCollapsible = previousCollapsible.previousElementSibling;
      }

      if (previousCollapsible) {
        // Trouver le .checkbox_container à l'intérieur
        const checkboxContainer = previousCollapsible.querySelector(".checkbox_container");

        if (checkboxContainer) {
          // Déplacer tous les enfants de .input_toggle_wrapper vers .checkbox_container
          while (toggleWrapper.firstChild) {
            checkboxContainer.appendChild(toggleWrapper.firstChild);
          }

          // Supprimer le wrapper vide
          toggleWrapper.remove();
        }
      }
    }

    // Fermer les collapsibles à partir du 7ème
    const collapsibles = this.querySelectorAll("collapsible-content");

    collapsibles.forEach((collapsible, index) => {
      if (index >= 7) {
        // À partir du 7ème élément (index 6), on ferme
        collapsible.setAttribute("data-open", "false");
        const contentInner = collapsible.querySelector(".collapsible_content_inner");
        if (contentInner) {
          contentInner.style.display = "none"; // Cacher directement sans animation
        }
      }
    });

    // Afficher tous les éléments et mettre "Afficher moins" si une catégorie contient un input checked
    const filterCategories = this.querySelectorAll(".filter_category_content");

    filterCategories.forEach((category) => {
      // Vérifier s'il y a au moins un input checkbox checked dans cette catégorie
      const checkedInput = category.querySelector('input[type="checkbox"]:checked');

      if (checkedInput) {
        // Supprimer tous les hidden_item de cette catégorie
        const hiddenItems = category.querySelectorAll(".checkbox_item.hidden_item");
        hiddenItems.forEach((item) => {
          item.classList.remove("hidden_item");
        });

        // Mettre à jour le bouton "Afficher plus/moins"
        const showMoreButton = category.querySelector(".filter_show_more");
        if (showMoreButton) {
          const textElement = showMoreButton.querySelector("p");
          const arrow = showMoreButton.querySelector(".arrow");

          if (textElement) {
            textElement.textContent = textElement.dataset.textLess || "Afficher moins";
          }
          if (arrow) {
            arrow.classList.add("open");
          }
        }
      }
    });
  }

  // Compter et afficher le nombre de filtres actifs
  updateFilterCount() {
    const form = this.querySelector("form");
    if (!form) return;

    let activeCount = 0;

    // Compter les checkboxes cochées (sauf sort_by et les disabled)
    const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked:not([disabled])');
    activeCount += checkboxes.length;

    // Compter les radios sélectionnés (en excluant le premier qui est le défaut - created-descending)
    const sortBy = form.querySelector('input[name="sort_by"]:checked');
    if (sortBy && sortBy.value !== "created-descending") {
      activeCount += 1;
    }

    // Compter les filtres de prix (si différents des valeurs min/max par défaut)
    const priceInputs = form.querySelectorAll("[data-price-input]");
    priceInputs.forEach((input) => {
      const rawValue = input.dataset.rawValue || this.getRawPrice(input.value);
      const baseMin = input.dataset.min;
      const baseMax = input.dataset.max;
      const isMinInput = input.classList.contains("range_input_min");
      const isMaxInput = input.classList.contains("range_input_max");

      // Vérifier si la valeur est différente de la valeur de base
      if (rawValue && ((isMinInput && rawValue !== baseMin) || (isMaxInput && rawValue !== baseMax))) {
        activeCount += 0.5; // On compte 0.5 pour chaque input de prix (min et max = 1 filtre)
      }
    });

    // Arrondir le compteur (au cas où on aurait des 0.5 des filtres de prix)
    activeCount = Math.ceil(activeCount);

    // Mettre à jour le badge sur le bouton des filtres
    const filterButton = document.querySelector('[data-drawer="drawer-filters"]');
    if (filterButton) {
      const badge = filterButton.querySelector(".filter_count_badge");
      if (badge) {
        if (activeCount > 0) {
          filterButton.classList.add("active");
          badge.textContent = activeCount;
          badge.style.display = "flex";
        } else {
          filterButton.classList.remove("active");
          badge.style.display = "none";
        }
      }
    }
  }

  // Formater un nombre avec séparateurs de milliers et symbole €
  formatPrice(value) {
    if (!value) return "";

    // Convertir en nombre et formater avec espaces comme séparateurs de milliers
    const num = parseInt(value.toString().replace(/\s/g, "").replace(/€/g, ""), 10);
    if (isNaN(num)) return "";

    return num.toLocaleString("fr-FR") + " €";
  }

  // Récupérer la valeur brute (sans formatage)
  getRawPrice(value) {
    if (!value) return "";
    return value.toString().replace(/\s/g, "").replace(/€/g, "");
  }

  // Initialiser le formatage des inputs de prix
  initPriceFormatting() {
    const priceInputs = this.querySelectorAll("[data-price-input]");

    priceInputs.forEach((input) => {
      // Formater la valeur initiale si elle existe
      if (input.value) {
        const rawValue = this.getRawPrice(input.value);
        input.value = this.formatPrice(rawValue);
        input.dataset.rawValue = rawValue;
      }

      // Gérer le focus - sélectionner tout le texte
      input.addEventListener("focus", (e) => {
        setTimeout(() => e.target.select(), 0);
      });

      // Gérer l'input - formater pendant la saisie
      input.addEventListener("input", (e) => {
        const cursorPosition = e.target.selectionStart;
        const oldValue = e.target.value;
        const rawValue = this.getRawPrice(oldValue);

        // Stocker la valeur brute
        input.dataset.rawValue = rawValue;

        // Formater la valeur
        const formattedValue = this.formatPrice(rawValue);

        if (formattedValue !== oldValue) {
          e.target.value = formattedValue;

          // Ajuster la position du curseur
          const diff = formattedValue.length - oldValue.length;
          const newPosition = cursorPosition + diff;
          e.target.setSelectionRange(newPosition, newPosition);
        }
      });

      // Gérer le blur - formater la valeur finale
      input.addEventListener("blur", (e) => {
        const rawValue = this.getRawPrice(e.target.value);
        if (rawValue) {
          e.target.value = this.formatPrice(rawValue);
          input.dataset.rawValue = rawValue;
        } else {
          e.target.value = "";
          input.dataset.rawValue = "";
        }
      });
    });
  }

  submitForm(event) {
    event.preventDefault();
    const searchParams = this.createSearchParams(event.target.closest("form"));
    this.renderResults(searchParams, event);
  }

  resetForm(event) {
    event.preventDefault();
    let url_base = "";
    this.renderResults(url_base, event, true, true);
  }

  createSearchParams(form) {
    const formData = new FormData(form);

    // Supprimer les inputs de recherche (utilisés uniquement pour filtrer les options localement)
    formData.delete("search");

    // Nettoyer les valeurs de prix avant de créer les paramètres
    const priceInputs = form.querySelectorAll("[data-price-input]");
    priceInputs.forEach((input) => {
      const paramName = input.dataset.paramName;
      const rawValue = input.dataset.rawValue || this.getRawPrice(input.value);

      // Récupérer les valeurs min/max de base
      const baseMin = input.dataset.min;
      const baseMax = input.dataset.max;

      // Vérifier si c'est un input min ou max
      const isMinInput = input.classList.contains("range_input_min");
      const isMaxInput = input.classList.contains("range_input_max");

      if (rawValue && paramName) {
        formData.delete(paramName);

        // Ne pas ajouter le paramètre si la valeur correspond à la valeur de base
        const shouldSkip = (isMinInput && rawValue === baseMin) || (isMaxInput && rawValue === baseMax);

        if (!shouldSkip) {
          formData.append(paramName, rawValue);
        }
      }
    });

    return new URLSearchParams(formData).toString();
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  getSections() {
    return [
      {
        section: document.getElementById("collection_products").dataset.id,
      },
    ];
  }

  renderResults(searchParams, event, updateURLHash = true, updateDrawer = true) {
    const sections = this.getSections();

    /*** @todo : Placer ici si besoin d'un effet de loading
     * Ex : Ajouter une classe "loading" à la section
     * Fin de l'effet de loading ***/

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      this.renderSectionFromFetch(url, event, updateDrawer);
    });

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  renderSectionFromFetch(url, event, updateDrawer = true) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.filterData = [...this.filterData, { html, url }];
        this.renderProductsList(html);
        this.renderProductCount(html);
        if (updateDrawer) {
          this.renderFilters(html, event);
        }
      });
  }

  renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, "text/html").querySelector(".collection-count").innerHTML;
    const container = document.querySelector(".collection-count");
    container.innerHTML = count;
  }

  renderFilters(html, event) {
    // Détecter quel input a déclenché l'événement (s'il s'agit d'un input de prix)
    let focusedInputParamName = null;
    if (event && event.target) {
      const targetInput = event.target.closest("[data-price-input]");
      if (targetInput) {
        focusedInputParamName = targetInput.dataset.paramName;
      }
    }

    // Conserver les valeurs des inputs de prix avant le rendu
    const priceInputs = document.querySelectorAll("[data-price-input]");
    const priceValues = {};

    priceInputs.forEach((input) => {
      const paramName = input.dataset.paramName;
      const rawValue = input.dataset.rawValue || this.getRawPrice(input.value);
      if (rawValue && paramName) {
        priceValues[paramName] = rawValue;
      }
    });

    // Conserver l'état des collapsibles (ouvert/fermé) avant le rendu
    const collapsibles = this.querySelectorAll("collapsible-content");
    const collapsiblesState = {};

    collapsibles.forEach((collapsible) => {
      // Utiliser le texte du titre h3 comme identifiant unique
      const title = collapsible.querySelector(".filter_category .h4");
      if (title) {
        const titleText = title.textContent.trim().replace(/\s+/g, " ");
        const isOpen = collapsible.getAttribute("data-open") === "true";
        collapsiblesState[titleText] = isOpen;
      }
    });

    // Mettre à jour le HTML
    document.querySelector(".filter_drawer_content_items_list").innerHTML = new DOMParser().parseFromString(html, "text/html").querySelector(".filter_drawer_content_items_list").innerHTML;

    // Réinitialiser les filtres (déplacer toggle wrapper et fermer collapsibles >= 7)
    this.initializeFilters();

    // Restaurer l'état des collapsibles
    const newCollapsibles = this.querySelectorAll("collapsible-content");
    newCollapsibles.forEach((collapsible) => {
      const title = collapsible.querySelector(".filter_category .h4");
      if (title) {
        const titleText = title.textContent.trim().replace(/\s+/g, " ");
        // Si on a un état sauvegardé pour ce collapsible, le restaurer
        if (collapsiblesState.hasOwnProperty(titleText)) {
          const shouldBeOpen = collapsiblesState[titleText];
          collapsible.setAttribute("data-open", shouldBeOpen.toString());

          // Mettre à jour l'affichage du contenu
          const contentInner = collapsible.querySelector(".collapsible_content_inner");
          if (contentInner) {
            contentInner.style.display = shouldBeOpen ? "block" : "none";
          }
        }
      }
    });

    // Réinitialiser le formatage des prix
    this.initPriceFormatting();

    // Réinitialiser les event listeners pour les champs de recherche et les boutons "show more"
    this.initFilterEventListeners();

    // Restaurer les valeurs des inputs de prix si elles ne sont pas déjà présentes
    const newPriceInputs = document.querySelectorAll("[data-price-input]");
    let inputToFocus = null;

    newPriceInputs.forEach((input) => {
      const paramName = input.dataset.paramName;
      const savedValue = priceValues[paramName];
      const currentRawValue = input.dataset.rawValue || this.getRawPrice(input.value);

      if (savedValue && !currentRawValue) {
        input.value = this.formatPrice(savedValue);
        input.dataset.rawValue = savedValue;
      }

      // Identifier l'input à refocuser
      if (focusedInputParamName && paramName === focusedInputParamName) {
        inputToFocus = input;
      }
    });

    // Remettre le focus sur l'input qui a été modifié
    if (inputToFocus) {
      setTimeout(() => {
        inputToFocus.focus();
        // Placer le curseur à la fin
        const valueLength = inputToFocus.value.length;
        inputToFocus.setSelectionRange(valueLength, valueLength);
      }, 0);
    }

    // Mettre à jour le compteur de filtres actifs
    this.updateFilterCount();
  }

  renderProductsList(html) {
    document.getElementById("collection_products").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("collection_products").innerHTML;
  }

  toggleShowMore(event, button) {
    event.preventDefault();
    // Trouver le conteneur parent
    const container = button.closest(".filter_category_content");
    if (!container) return;

    // Trouver tous les éléments cachés
    const hiddenItems = container.querySelectorAll(".checkbox_item.hidden_item");
    const textElement = button.querySelector("p");
    const arrow = button.querySelector(".arrow");

    // Si des éléments sont cachés, les afficher
    if (hiddenItems.length > 0) {
      hiddenItems.forEach((item) => {
        item.classList.remove("hidden_item");
      });
      // Changer le texte pour "Afficher moins"
      if (textElement) {
        textElement.textContent = textElement.dataset.textLess || "Afficher moins";
      }
      if (arrow) {
        arrow.classList.add("open");
      }
    } else {
      // Sinon, cacher les éléments après le 5ème
      const allItems = container.querySelectorAll(".checkbox_item");
      allItems.forEach((item, index) => {
        if (index >= 5) {
          item.classList.add("hidden_item");
        }
      });
      // Changer le texte pour "Afficher plus"
      if (textElement) {
        textElement.textContent = textElement.dataset.textMore || "Afficher plus";
      }
      if (arrow) {
        arrow.classList.remove("open");
      }
    }
  }
}

// Enregistrer le Custom Element
customElements.define("filters-form", FiltersForm);

/**
 * Range Filter Component - Double curseur pour filtres numériques
 */
class RangeFilterComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderElement = this.querySelector(".range_slider");
    this.minInput = this.querySelector(".range_input_min");
    this.maxInput = this.querySelector(".range_input_max");
    this.hiddenContainer = this.querySelector("[data-range-hidden-container]");
    this.filterWrapper = this.querySelector(".range_filter_wrapper");

    // Détecter si c'est un filtre de prix
    this.isPriceFilter = this.minInput?.hasAttribute("data-price-input") || false;

    // Lire les valeurs depuis les attributs data-* du slider ou depuis les inputs
    if (this.sliderElement && this.sliderElement.dataset.min) {
      // Utiliser les attributs data-* du slider (filtres range standards)
      this.minRange = parseFloat(this.sliderElement.dataset.min);
      this.maxRange = parseFloat(this.sliderElement.dataset.max);

      if (this.isPriceFilter) {
        // Pour les prix, extraire la valeur brute
        this.minInputValue = parseFloat(this.sliderElement.dataset.currentMin || this.getRawPrice(this.minInput.value) || this.minRange);
        this.maxInputValue = parseFloat(this.sliderElement.dataset.currentMax || this.getRawPrice(this.maxInput.value) || this.maxRange);
      } else {
        this.minInputValue = parseFloat(this.sliderElement.dataset.currentMin || this.minInput.value);
        this.maxInputValue = parseFloat(this.sliderElement.dataset.currentMax || this.maxInput.value);
      }
    } else {
      // Fallback : utiliser les valeurs des inputs ou leurs attributs data-*
      this.minRange = parseFloat(this.minInput.dataset.min || this.minInput.min || this.minInput.value);
      this.maxRange = parseFloat(this.maxInput.dataset.max || this.maxInput.max || this.maxInput.value);

      if (this.isPriceFilter) {
        this.minInputValue = parseFloat(this.getRawPrice(this.minInput.value) || this.minRange);
        this.maxInputValue = parseFloat(this.getRawPrice(this.maxInput.value) || this.maxRange);
      } else {
        this.minInputValue = parseFloat(this.minInput.value);
        this.maxInputValue = parseFloat(this.maxInput.value);
      }
    }
  }

  // Fonction pour extraire le prix brut (sans formatage)
  getRawPrice(value) {
    if (!value) return "";
    return value.toString().replace(/\s/g, "").replace(/€/g, "");
  }

  // Fonction pour formater le prix
  formatPrice(value) {
    if (!value) return "";
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return "";
    return new Intl.NumberFormat("fr-FR").format(numValue) + " €";
  }

  // Fonction pour formater les nombres avec séparateur des milliers
  formatNumber(value) {
    if (!value && value !== 0) return "";
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return "";
    return new Intl.NumberFormat("fr-FR").format(numValue);
  }

  // Fonction pour extraire le nombre brut (sans formatage)
  getRawNumber(value) {
    if (!value) return "";
    return value.toString().replace(/\s/g, "");
  }

  // Fonction pour mettre à jour les inputs hidden pour les filtres range (non-prix)
  updateHiddenInputs() {
    if (this.isPriceFilter || !this.hiddenContainer) return;

    // Récupérer le param_name depuis le wrapper
    const paramName = this.filterWrapper?.dataset.filterParam;
    if (!paramName) return;

    // Vider le conteneur
    this.hiddenContainer.innerHTML = "";

    // Créer des inputs checkbox hidden pour toutes les valeurs entre min et max
    for (let i = this.minInputValue; i <= this.maxInputValue; i++) {
      const checkbox = document.createElement("input");
      checkbox.type = "checkbox";
      checkbox.name = paramName;
      checkbox.value = i;
      checkbox.checked = true;
      checkbox.style.display = "none";
      this.hiddenContainer.appendChild(checkbox);
    }
  }

  connectedCallback() {
    // Attendre que noUiSlider soit chargé
    if (typeof noUiSlider === "undefined") {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }
    this.initializeSlider();
    this.attachInputListeners();
  }

  initializeSlider() {
    if (!this.sliderElement) {
      console.warn("RangeFilterComponent: sliderElement not found");
      return;
    }

    // Vérifier si le slider a déjà été initialisé
    if (this.sliderElement.noUiSlider) {
      return;
    }

    this.slider = noUiSlider.create(this.sliderElement, {
      start: [this.minInputValue, this.maxInputValue],
      connect: [false, true, false], // [avant le premier handle, entre les handles, après le second handle]
      range: {
        min: this.minRange,
        max: this.maxRange,
      },
      step: 1,
      format: {
        to: (value) => Math.round(value),
        from: (value) => Number(value),
      },
    });

    // Mettre à jour les inputs visuellement pendant le déplacement (sans soumettre le formulaire)
    this.slider.on("update", (values) => {
      this.minInputValue = Math.round(parseFloat(values[0]));
      this.maxInputValue = Math.round(parseFloat(values[1]));
      this.updateInputs(false); // false = ne pas déclencher l'événement input
    });

    // Soumettre le formulaire uniquement quand on relâche le slider
    this.slider.on("change", (values) => {
      this.minInputValue = Math.round(parseFloat(values[0]));
      this.maxInputValue = Math.round(parseFloat(values[1]));
      this.updateInputs(true); // true = déclencher l'événement input pour soumettre le formulaire
    });

    // Formater les valeurs initiales
    this.updateInputs(false);
  }

  attachInputListeners() {
    // Gérer les changements manuels des inputs (prix et autres filtres range)
    if (this.minInput) {
      this.minInput.addEventListener("change", () => {
        const rawValue = this.isPriceFilter ? this.getRawPrice(this.minInput.value) : this.getRawNumber(this.minInput.value);
        if (rawValue) {
          const numValue = parseFloat(rawValue);
          if (!isNaN(numValue) && numValue >= this.minRange && numValue <= this.maxRange) {
            this.slider.set([numValue, null]);
          }
        }
      });
    }

    if (this.maxInput) {
      this.maxInput.addEventListener("change", () => {
        const rawValue = this.isPriceFilter ? this.getRawPrice(this.maxInput.value) : this.getRawNumber(this.maxInput.value);
        if (rawValue) {
          const numValue = parseFloat(rawValue);
          if (!isNaN(numValue) && numValue >= this.minRange && numValue <= this.maxRange) {
            this.slider.set([null, numValue]);
          }
        }
      });
    }
  }

  updateInputs(triggerSubmit = false) {
    if (this.minInput) {
      if (this.isPriceFilter) {
        this.minInput.value = this.formatPrice(this.minInputValue);
        this.minInput.dataset.rawValue = this.minInputValue.toString();
      } else {
        this.minInput.value = this.formatNumber(this.minInputValue);
      }
      // Déclencher l'événement input pour que le formulaire se soumette (seulement si demandé)
      if (triggerSubmit) {
        this.minInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }
    if (this.maxInput) {
      if (this.isPriceFilter) {
        this.maxInput.value = this.formatPrice(this.maxInputValue);
        this.maxInput.dataset.rawValue = this.maxInputValue.toString();
      } else {
        this.maxInput.value = this.formatNumber(this.maxInputValue);
      }
      // Déclencher l'événement input pour que le formulaire se soumette (seulement si demandé)
      if (triggerSubmit) {
        this.maxInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
    }

    // Mettre à jour les inputs hidden pour les filtres range (année, kilométrage)
    this.updateHiddenInputs();
  }
}

customElements.define("range-filter-component", RangeFilterComponent);

/*** Classes Utilitaires ***/
// Header
class CustomHeader extends HTMLElement {
  constructor() {
    super();
    this.$header = null;
    this.$menu = null;
    this.$overlay = null;
    this.isInitialized = false;
    this.lastScrollTop = 0;
    this.scrollThreshold = 5;
  }

  connectedCallback() {
    if (!this.isInitialized) {
      this.init();
      this.isInitialized = true;
    }
  }

  init() {
    // Initialisation des références DOM
    this.$header = $(this);
    this.$headerContainer = this.$header.find(".header_container");
    this.$menu = this.$header.find(".menu");
    this.$overlay = $(".overlay_header");

    // Initialisation de tous les écouteurs d'événements
    // si on est pas sur mobile
    if ($(window).width() < 950) {
      this.initMobileSubmenus();
    }
    this.initMenuItems();
    this.initBurger();
    this.initCloseMenu();
    this.initOverlay();
    this.initScrollBehavior();
  }

  /**
   * Gestion du comportement du header au scroll
   */
  initScrollBehavior() {
    const self = this;

    $(window).on("scroll", function () {
      self.handleScroll();
    });
  }

  /**
   * Gère l'affichage/masquage du header selon le sens du scroll
   */
  handleScroll() {
    const currentScrollTop = $(window).scrollTop();
    const scrollThreshold = $("#announcement").length ? $("#announcement").outerHeight() : 0;

    // Retirer toutes les classes si on est tout en haut de la page
    if (currentScrollTop <= scrollThreshold) {
      this.$headerContainer.removeClass("fixed");
      this.$headerContainer.removeClass("scrollup");
      this.lastScrollTop = currentScrollTop;
      return;
    }

    // Calculer la différence de scroll
    const scrollDifference = Math.abs(currentScrollTop - this.lastScrollTop);

    // Ne réagir que si le scroll dépasse le seuil
    if (scrollDifference < this.scrollThreshold) {
      return;
    }

    // Scroll vers le bas
    if (currentScrollTop > this.lastScrollTop) {
      // Ajouter la classe fixed seulement si on a dépassé 200px
      if (currentScrollTop >= 200) {
        this.$headerContainer.addClass("fixed");
        this.$headerContainer.removeClass("scrollup");
      }
    }
    // Scroll vers le haut - afficher le header (pas de condition sur les 200px)
    else if (currentScrollTop >= 200) {
      this.$headerContainer.addClass("scrollup");
    }

    this.lastScrollTop = currentScrollTop;
  }

  /**
   * Gestion des items du menu principal (desktop)
   */
  initMenuItems() {
    const self = this;
    let hoverTimeout = null;

    // Gérer l'ouverture au survol
    this.$header.find(".menu li").on("mouseenter", function (e) {
      const $li = $(this);
      const $submenu = $li.find(".sub_menu");
      const $otherSubmenus = self.$header.find(".menu .sub_menu").not($submenu);
      const hasActiveSubmenu = $otherSubmenus.hasClass("active");

      // Annuler tout timeout de fermeture en cours
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }

      // Gestion des liens actifs
      $li.find("> a").addClass("active");
      self.$header.find(".menu li").not($li).find("> a").removeClass("active");

      if ($submenu.length) {
        // Si un sous-menu est déjà actif
        if (hasActiveSubmenu && !$submenu.hasClass("active")) {
          // Fermer les autres sous-menus
          $otherSubmenus.removeClass("active");
          $otherSubmenus.find("a").removeClass("active");

          // Afficher l'overlay
          self.$overlay.addClass("active");

          // Attendre la fin de l'animation (300ms) avant d'ouvrir le nouveau
          setTimeout(function () {
            $submenu.addClass("active");
          }, 200);
        } else {
          // Fermer tous les autres sous-menus
          $otherSubmenus.removeClass("active");

          // Ouvrir le sous-menu actuel
          $submenu.addClass("active");

          // Afficher l'overlay
          self.$overlay.addClass("active");
        }
      } else {
        self.$header.find(".menu .sub_menu").removeClass("active");
        self.$overlay.removeClass("active");
      }
    });

    // Gérer la fermeture quand on quitte le menu
    this.$header.find(".menu li").on("mouseleave", function (e) {
      const $li = $(this);
      const $submenu = $li.find(".sub_menu");

      // Si le sous-menu est ouvert, attendre un peu avant de fermer
      // pour laisser le temps à l'utilisateur de passer dans le sous-menu
      if ($submenu.length && $submenu.hasClass("active")) {
        hoverTimeout = setTimeout(function () {
          $submenu.removeClass("active");
          self.$overlay.removeClass("active");
          $li.find("> a").removeClass("active");
        }, 200);
      } else {
        $li.find("> a").removeClass("active");
      }
    });

    // Maintenir le sous-menu ouvert quand on est dedans
    this.$header.find(".menu .sub_menu").on("mouseenter", function (e) {
      // Annuler le timeout de fermeture
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }
    });

    // Fermer le sous-menu quand on quitte le sous-menu
    this.$header.find(".menu .sub_menu").on("mouseleave", function (e) {
      const $submenu = $(this);
      hoverTimeout = setTimeout(function () {
        $submenu.removeClass("active");
        self.$overlay.removeClass("active");
        self.$header.find(".menu li a").removeClass("active");
      }, 200);
    });

    // Empêcher la fermeture quand on clique dans le sous-menu
    this.$header.find(".menu .sub_menu").on("click", function (e) {
      // Laisser remonter les clics d'ouverture de drawer (push) jusqu'au DrawerManager
      if ($(e.target).closest("[data-drawer]").length) {
        return;
      }
      e.stopPropagation();
    });

    // Fermer le sous-menu quand on clique en dehors
    $(document).on("click", function (e) {
      if (!$(e.target).closest("header .menu").length) {
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
        self.$header.find(".menu .sub_menu").removeClass("active");
        self.$overlay.removeClass("active");
        self.$header.find(".menu li a").removeClass("active");
      }
    });
  }

  /**
   * Gestion du menu burger (mobile)
   */
  initBurger() {
    const self = this;

    this.$header.find(".burger").click(function (e) {
      e.preventDefault();
      self.$menu.addClass("active");
      self.$overlay.addClass("active");
    });
  }

  /**
   * Gestion de la fermeture du menu
   */
  initCloseMenu() {
    const self = this;

    this.$header.find(".close_menu").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      self.$menu.removeClass("active");
      self.$header.find(".sub_menu").removeClass("active");
      self.$overlay.removeClass("active");
      self.resetActiveSubmenu();
    });
  }

  /**
   * Gestion de l'overlay
   */
  initOverlay() {
    const self = this;

    this.$overlay.click(function (e) {
      self.$menu.removeClass("active");
      self.$header.find(".sub_menu").removeClass("active");
      $(this).removeClass("active");
    });
  }

  // En mobile si on click sur .sub_menu_content .h4 on slide toggle la nav qui suit
  initMobileSubmenus() {
    const self = this;

    this.$header.find(".sub_menu_content .h4").click(function (e) {
      const $title = $(this);
      const $submenu = $title.closest(".sub_menu");
      const $container = $title.parent("div");
      const wasActive = $title.hasClass("active");

      // Supprimer la classe active uniquement des éléments du sub_menu concerné
      $submenu.find(".sub_menu_content .h4").removeClass("active");
      $submenu.find(".sub_menu_content .h4").parent("div").removeClass("active");
      $submenu.find(".sub_menu_content .h4").next("nav").slideUp();

      // Si l'élément n'était pas actif, l'activer
      if (!wasActive) {
        $container.addClass("active");
        $title.addClass("active");
        $title.next("nav").slideDown();
      }
    });

    // Gestion du clic sur les items de menu qui ont un sous-menu (mobile uniquement)
    this.$header.find(".menu > ul > li > a").click(function (e) {
      // Ne fonctionne qu'en mobile
      if ($(window).width() > 950) {
        return;
      }

      const $link = $(this);
      const $submenu = $link.next(".sub_menu");

      // Si l'item a un sous-menu
      if ($submenu.length) {
        e.preventDefault();
        $submenu.addClass("active");
      }
    });

    // Gestion du bouton retour
    this.$header.find(".back_to_menu").click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).closest(".sub_menu").removeClass("active");
      self.resetActiveSubmenu();
    });
  }

  // Remet tous les sub_menu à leur état initial (premier élément actif)
  resetActiveSubmenu() {
    const self = this;

    self.$header.find(".sub_menu_content h3").removeClass("active");
    self.$header.find(".sub_menu_content h3").parent("div").removeClass("active");
    self.$header.find(".sub_menu_content h3").next("nav").slideUp();

    self.$header.find(".sub_menu").each(function () {
      const $submenu = $(this);
      const $firstTitle = $submenu.find(".sub_menu_content > div > h3:first");

      if ($firstTitle.length) {
        $firstTitle.addClass("active");
        $firstTitle.parent("div").addClass("active");
        $firstTitle.next("nav").slideDown();
      }
    });
  }
}

customElements.define("custom-header", CustomHeader);

// Announcement Bar
class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.closeBar = this.querySelector(".close");
    this.storageKey = "announcement-bar-closed";
  }

  connectedCallback() {
    // Vérifier si la barre a déjà été fermée
    if (this.isBarClosed()) {
      this.remove();
      return;
    }

    // Afficher la barre (elle est cachée par défaut en CSS)
    this.classList.add("is-visible");

    // Ajouter l'événement de fermeture
    if (this.closeBar) {
      this.closeBar.addEventListener("click", () => this.closeAnnouncement());
    }
  }

  isBarClosed() {
    return localStorage.getItem(this.storageKey) === "true";
  }

  closeAnnouncement() {
    // Enregistrer dans le localStorage
    localStorage.setItem(this.storageKey, "true");

    // Retirer complètement la barre du DOM
    this.remove();
  }
}

customElements.define("announcement-bar", AnnouncementBar);

// Search Bar
class SearchBar extends HTMLElement {
  constructor() {
    super();
  }

  // Liste des attributs à observer
  static get observedAttributes() {
    return ["placeholder"];
  }

  // Appelé automatiquement quand l'élément est ajouté au DOM
  connectedCallback() {
    this.init();
  }

  // Appelé quand un attribut observé change
  attributeChangedCallback(name, oldValue, newValue) {
    if (this.isInitialized && name === "placeholder" && oldValue !== newValue) {
      this.$input.attr("placeholder", newValue || "");
    }
  }

  // Initialisation
  init() {
    this.$searchBar = $(this);
    this.$input = this.$searchBar.find("input");
    this.$searchPanel = this.$searchBar.find(".search_panel");
    this.$removeBtn = this.$searchBar.find(".search_bar_remove");
    this.$resultsPanel = this.$searchBar.find(".search_results");
    this.$suggestionsPanel = this.$searchBar.find(".search_suggestions");
    this.$cancelBtn = this.$searchBar.prev(".cancel_search");
    this.$header = $(".header");

    /** Nouveaux éléments */
    this.input = this.querySelector("input");
    this.searchTerm = "";

    // Récupérer et stocker le placeholder original
    // D'abord vérifier l'attribut sur l'élément search-bar
    const placeholder = this.getAttribute("placeholder");
    if (placeholder) {
      this.$input.attr("placeholder", placeholder);
      this.originalPlaceholder = placeholder;
    } else {
      // Sinon récupérer le placeholder existant de l'input
      this.originalPlaceholder = this.$input.attr("placeholder") || "";
    }

    // Vérifier si l'input a déjà une valeur au chargement
    if (this.$input.val()) {
      this.$removeBtn.show();
    }

    if (this.input) {
      this.input.form.addEventListener("reset", this.resetSearch.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    this.initEventListeners();
    this.updateHeaderHeight();
  }

  /*** DEBUT NOUVEAU CODE */
  onChange() {
    // this.toggleResetButton();
    const newSearchTerm = this.getQuery();

    // Si le champ de recherche est vide, vider le contenu des résultats
    if (!newSearchTerm) {
      const searchResults = this.querySelector(".search_results");
      if (searchResults) {
        searchResults.innerHTML = "";
      }
      this.querySelector(".search_results_wrapper")?.remove();
      this.searchTerm = "";
      return;
    }

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector(".search_results_wrapper")?.remove();
    }

    this.searchTerm = newSearchTerm;

    this.getSearchResults(this.searchTerm);
  }

  getQuery() {
    return this.input.value.trim();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    /* this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    } */

    /* fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=ajax-predictive-search&resources[limit]=6&resources[type]=product`, {
      signal: this.abortController.signal,
    }) */
    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&section_id=ajax-predictive-search&resources[limit]=4&resources[options][fields]=title,variants.sku,variants.barcode&resources[limit_scope]=each`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.querySelector(".search_results_wrapper")?.remove();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector(".search_results_wrapper").innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        /* this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        }); */
        //this.renderSearchResults(resultsMarkup);
        this.querySelector(".search_results").innerHTML = resultsMarkup;
      })
      .catch((error) => {
        console.log(error);
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.querySelector(".search_results_wrapper")?.remove();
        throw error;
      });
  }

  /*** FIN NOUVEAU CODE */

  // Méthode pour mettre à jour la hauteur du header
  updateHeaderHeight() {
    if ($(window).width() <= 950) {
      const headerHeight = this.$header.outerHeight();
      document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
    }
  }

  // Méthode pour fermer tous les panels
  closePanels() {
    this.$searchPanel.removeClass("active");
    this.$suggestionsPanel.removeClass("active");
    this.$resultsPanel.removeClass("active");
  }

  // Méthode pour vider l'input
  clearInput() {
    this.$input.val("");
    this.$removeBtn.hide();
  }

  // Méthode pour restaurer le placeholder
  restorePlaceholder() {
    if (this.originalPlaceholder) {
      this.$input.attr("placeholder", this.originalPlaceholder);
    }
  }

  hideOverlayHeader() {
    const overlay = document.querySelector(".overlay_header");
    if (overlay) {
      overlay.classList.remove("active");
    }
  }

  showOverlayHeader() {
    const overlay = document.querySelector(".overlay_header");
    if (overlay) {
      overlay.classList.add("active");
    }
  }

  // Méthode pour réinitialiser complètement la recherche
  resetSearch() {
    this.closePanels();
    this.restorePlaceholder();
    this.$cancelBtn.hide();
    this.hideOverlayHeader();
    this.$searchBar.find(".popular_searches").show();
    this.$resultsPanel.empty();
  }

  // Initialisation des événements
  initEventListeners() {
    // Afficher/masquer le bouton close selon la saisie
    this.$input.on("input", () => {
      const $popularSearches = this.$searchBar.find(".popular_searches");

      if (this.$input.val().length > 0) {
        this.$removeBtn.show();
        this.$suggestionsPanel.removeClass("active");
        this.$resultsPanel.addClass("active");
        $popularSearches.hide();
      } else {
        this.$removeBtn.hide();
        this.$suggestionsPanel.addClass("active");
        this.$resultsPanel.removeClass("active");
        $popularSearches.show();
        this.$resultsPanel.empty();
      }
    });

    // Au focus sur l'input, supprimer le placeholder
    this.$input.on("focus", () => {
      // Ajouter la class active a la search-bar
      this.$searchBar.addClass("active");
      this.$input.attr("placeholder", "");
    });

    // Au blur sur l'input, remettre le placeholder si vide
    this.$input.on("blur", () => {
      const inputValue = this.$input.val();
      // Retirer la class active a la search-bar
      this.$searchBar.removeClass("active");
      // Remettre le placeholder si l'input est vide
      if (!inputValue || inputValue.trim() === "") {
        if (this.originalPlaceholder) {
          this.$input.attr("placeholder", this.originalPlaceholder);
        }
      }
    });

    // Au click sur l'input
    this.$input.on("click", (e) => {
      e.stopPropagation(); // Empêche la propagation vers document.click
      if (this.$searchPanel.length) {
        $(".sub_menu").removeClass("active");
        this.updateHeaderHeight(); // Mettre à jour la hauteur du header avant d'afficher le panel
        this.$searchPanel.addClass("active");
        this.$suggestionsPanel.addClass("active");
        this.showOverlayHeader();

        if ($(window).width() <= 950) {
          this.$cancelBtn.show();
          // on block le scroll de la page
          $("body").addClass("no-scroll");
        }
      }
    });

    // Vider l'input au clic sur le bouton close
    this.$removeBtn.on("click", (e) => {
      e.stopPropagation();
      this.clearInput();
      this.$input.focus();
      this.$suggestionsPanel.addClass("active");
      this.$resultsPanel.removeClass("active");
      this.$searchBar.find(".popular_searches").show();
      this.$resultsPanel.empty();
    });

    // Fermer les searchPanel quand on clique en dehors
    $(document).on("click", (e) => {
      if (!$(e.target).closest(".search").length) {
        // Vérifier si le search panel est actif
        if (this.$searchPanel.hasClass("active")) {
          this.resetSearch();
          // on débloque le scroll de la page seulement si aucun drawer n'est ouvert
          if (!window.drawerManagerInstance || !window.drawerManagerInstance.activeDrawer) {
            $("body").removeClass("no-scroll");
          }
        }
      }
    });

    // fermer la search-bar au clic sur le bouton cancel en mobile
    if (this.$searchPanel.length) {
      this.$cancelBtn.on("click", (e) => {
        e.stopPropagation();
        this.resetSearch();
        // on débloque le scroll de la page seulement si aucun drawer n'est ouvert
        if (!window.drawerManagerInstance || !window.drawerManagerInstance.activeDrawer) {
          $("body").removeClass("no-scroll");
        }
      });
    }

    // Empêcher la fermeture quand on clique sur la search-bar
    this.$searchBar.on("click", (e) => {
      e.stopPropagation();
    });

    // Fermer les panels au scroll (uniquement sur desktop)
    $(window).on("scroll", () => {
      if (this.$searchPanel.hasClass("active") && $(window).width() > 950) {
        this.resetSearch();
      }
    });

    // Mettre à jour la hauteur du header lors du redimensionnement
    $(window).on("resize", () => {
      this.updateHeaderHeight();
    });
  }
}

customElements.define("search-bar", SearchBar);

// Products list swiper
class Slideshow extends HTMLElement {
  constructor() {
    super();
    this.nbPerSlide = this.dataset.nbPerSlide ? this.dataset.nbPerSlide : 1;
    this.autoplay = this.dataset.autoplay === "true" ? true : false;
    this.navigation = this.dataset.navigation === "true" ? true : false;
    this.pagination = this.dataset.pagination === "true" ? true : false;
    this.spaceBetween = this.dataset.spaceBetween ? this.dataset.spaceBetween : 24;
    this.freeMode = this.dataset.freeMode === "true" ? true : false;
    this.loop = this.dataset.loop === "true" ? true : false;
    this.mobileLoop = this.dataset.mobileLoop === "true" ? true : false;
    this.mobileNbPerSlide = this.dataset.mobileNbPerSlide ? this.dataset.mobileNbPerSlide : 1;
    this.mobileNavigation = this.dataset.mobileNavigation === "true" ? true : false;
    this.mobilePagination = this.dataset.mobilePagination === "true" ? true : false;
    this.mobileFreeMode = this.dataset.mobileFreeMode === "true" ? true : false;
  }

  connectedCallback() {
    this.initializeSlideshow();
  }

  initializeSlideshow() {
    new Swiper(this.querySelector(".swiper"), {
      slidesPerView: this.mobileNbPerSlide === "auto" ? "auto" : parseInt(this.mobileNbPerSlide),
      loop: this.loop,
      spaceBetween: parseInt(this.spaceBetween),
      freeMode: this.mobileFreeMode,
      navigation: {
        nextEl: this.querySelector(".slideshow_button_next"),
        prevEl: this.querySelector(".slideshow_button_prev"),
        enabled: this.mobileNavigation,
      },
      breakpoints: {
        768: {
          slidesPerView: this.nbPerSlide === "auto" ? "auto" : parseInt(this.nbPerSlide),
          loop: this.loop,
          spaceBetween: parseInt(this.spaceBetween),
          freeMode: this.freeMode,
          navigation: {
            enabled: this.navigation,
          },
        },
      },
      on: {
        init: () => {
          // on place la classe loaded sur .reviews_slider
          this.classList.add("loaded");
        },
      },
    });
  }
}
customElements.define("slide-show", Slideshow);

// Collapsible content
class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".collapsible_content_inner");
  }

  connectedCallback() {
    // Click on collapsible title
    this.addEventListener("click", this.toggleContent.bind(this));

    if (this.content) {
      this.content.addEventListener("click", (e) => {
        e.stopPropagation();
      });
    }

    // Si data-open="true", afficher le contenu sans basculer l'attribut
    if (this.getAttribute("data-open") === "true") {
      const contentInner = this.querySelector(".collapsible_content_inner");
      if (contentInner) {
        $(contentInner).show();
      }
    }
  }

  toggleContent() {
    const isOpen = this.getAttribute("data-open") === "true";
    this.setAttribute("data-open", isOpen ? "false" : "true");
    $(this.querySelector(".collapsible_content_inner")).slideToggle(200);
  }
}
customElements.define("collapsible-content", CollapsibleContent);

class Comparison extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
    // SOURCE DE VÉRITÉ UNIQUE : Tableau contenant toutes les données des véhicules
    this.comparisonState = [];
    // Tableau contenant uniquement les handles des produits en comparaison
    this.productHandles = [];
    // Debounce "first" : bloquer les actions pendant 100ms après le premier clic
    this.isActionBlocked = false;
    this.debounceDelay = 100;
  }

  // Appelé automatiquement quand l'élément est ajouté au DOM
  connectedCallback() {
    this.init();
  }

  // Initialisation
  init() {
    if (this.isInitialized) return;

    this.$comparison = $(this);
    this.initEventListeners();
    this.initializeComparisonState();
    this.initResizeHandler();

    this.isInitialized = true;
  }

  // ============ DEBOUNCE FIRST ============
  // Bloque les actions pendant 100ms après le premier clic
  blockActions() {
    this.isActionBlocked = true;
    setTimeout(() => {
      this.isActionBlocked = false;
    }, this.debounceDelay);
  }

  // Vérifie si une action est bloquée
  canPerformAction() {
    return !this.isActionBlocked;
  }

  // Fonction pour détecter si on est en mobile (1024px et plus)
  isTablet() {
    return window.innerWidth <= 1024;
  }

  isMobile() {
    return window.innerWidth <= 769;
  }

  // Fonction pour obtenir la limite maximale de véhicules selon la taille d'écran
  getMaxVehiclesLimit() {
    return this.isTablet() ? 2 : 3;
  }

  // ============ Méthodes de gestion de la comparaison ============

  // Fonction pour obtenir la limite maximale selon la taille d'écran
  getMaxVehicles() {
    if (typeof window !== "undefined" && window.innerWidth <= 769) {
      return 2;
    }
    return 3; // Desktop par défaut
  }

  // Récupérer la liste des véhicules en comparaison (IDs uniquement pour compatibilité)
  getVehicles() {
    return this.comparisonState.map((vehicle) => vehicle.id);
  }

  // Récupérer la liste des handles des produits en comparaison
  getProductHandles() {
    return this.productHandles;
  }

  // Synchroniser le tableau des handles avec le comparisonState (utile pour le débogage)
  syncProductHandles() {
    this.productHandles = this.comparisonState.map((vehicle) => vehicle.handle).filter((handle) => handle);
  }

  // Récupérer quelques données d'un véhicule pour l'afficher dans le comparateur
  getVehicleDataFromDOM(vehicleId) {
    var $vehicleCard = $('.product_card[data-id="' + vehicleId + '"]');
    if ($vehicleCard.length === 0) return null;

    return {
      id: vehicleId,
      handle: $vehicleCard.attr("data-product-handle") || "",
      name: $vehicleCard.find(".vehicle_name strong").text() || "",
      specs: $vehicleCard.find(".vehicle_name span").text() || "",
      image: $vehicleCard.find(".van_picture img").attr("src") || $vehicleCard.find("img").first().attr("src") || "",
      url: $vehicleCard.find("a").first().attr("href") || "",
    };
  }

  // Ajouter un véhicule au state (avec toutes ses données)
  addVehicle(vehicleId) {
    var maxVehicles = this.getMaxVehicles();

    if (this.comparisonState.length >= maxVehicles) {
      return { success: false, reason: "full" };
    }

    // Vérifier si le véhicule existe déjà
    if (this.comparisonState.some((v) => v.id === vehicleId)) {
      return { success: false, reason: "duplicate" };
    }

    var vehicleData = this.getVehicleDataFromDOM(vehicleId);
    if (!vehicleData) {
      return { success: false, reason: "not_found" };
    }

    // Ajouter au state
    this.comparisonState.push(vehicleData);

    // Ajouter le handle au tableau des handles
    if (vehicleData.handle) {
      this.productHandles.push(vehicleData.handle);
    }

    // Mettre à jour le DOM complet depuis le state
    this.renderDOM();

    return { success: true, action: "added", count: this.comparisonState.length };
  }

  // Supprimer un véhicule du state
  removeVehicle(vehicleId) {
    var index = this.comparisonState.findIndex((v) => v.id === vehicleId);

    if (index === -1) {
      return { success: false, reason: "not_found" };
    }

    // Récupérer le handle avant de supprimer
    var vehicleHandle = this.comparisonState[index].handle;

    // Supprimer du state
    this.comparisonState.splice(index, 1);

    // Supprimer le handle du tableau des handles
    if (vehicleHandle) {
      var handleIndex = this.productHandles.indexOf(vehicleHandle);
      if (handleIndex !== -1) {
        this.productHandles.splice(handleIndex, 1);
      }
    }

    // Mettre à jour le DOM complet depuis le state
    this.renderDOM();

    return { success: true, action: "deleted", count: this.comparisonState.length };
  }

  // Vider la comparaison
  clearVehicles() {
    this.comparisonState = [];
    this.productHandles = [];

    // Mettre à jour le DOM complet depuis le state
    this.renderDOM();

    return { success: true, action: "cleared", count: 0 };
  }

  // Vérifier si un véhicule est en comparaison
  hasVehicle(vehicleId) {
    return this.comparisonState.some((v) => v.id === vehicleId);
  }

  // Nettoyer les véhicules en excès selon la limite actuelle
  enforceLimit() {
    var maxVehicles = this.getMaxVehicles();
    var removedVehicles = [];

    while (this.comparisonState.length > maxVehicles) {
      var removed = this.comparisonState.pop();
      removedVehicles.push(removed.id);

      // Supprimer aussi le handle du tableau des handles
      if (removed.handle) {
        var handleIndex = this.productHandles.indexOf(removed.handle);
        if (handleIndex !== -1) {
          this.productHandles.splice(handleIndex, 1);
        }
      }
    }

    if (removedVehicles.length > 0) {
      // Mettre à jour le DOM complet depuis le state
      this.renderDOM();
    }

    return {
      success: true,
      removedVehicles: removedVehicles,
      count: this.comparisonState.length,
    };
  }

  // Cette méthode reconstruit TOUT le DOM depuis le state unique (comparisonState)
  renderDOM() {
    var maxLimit = this.getMaxVehiclesLimit();
    var nbTotal = this.comparisonState.length;
    var $comparisonSlots = $(".comparison_slot");

    // 1. RENDER DES SLOTS DE COMPARAISON
    if ($comparisonSlots.length > 0) {
      // Masquer/afficher le 3ème slot selon la taille d'écran
      if (this.isTablet()) {
        $comparisonSlots.eq(2).hide();
      } else {
        $comparisonSlots.eq(2).show();
      }

      // Remplir les slots depuis le state
      for (var i = 0; i < maxLimit; i++) {
        var $slot = $comparisonSlots.eq(i);

        if (i < this.comparisonState.length) {
          // Remplir le slot avec les données du véhicule
          var vehicleData = this.comparisonState[i];
          this.populateSlot($slot, vehicleData);
        } else {
          // Vider le slot
          $slot.addClass("empty").html("<p>Ajouter un van à comparer</p>").removeAttr("data-vehicle-id");
        }
      }
    }

    // 2. RENDER DES BOUTONS DE COMPARAISON SUR LES CARTES
    // Retirer toutes les classes active d'abord
    $(".product_card .compare_wrapper").removeClass("active");

    // Ajouter la classe active aux véhicules dans le state
    this.comparisonState.forEach(function (vehicle) {
      $('.product_card[data-id="' + vehicle.id + '"] .compare_wrapper').addClass("active");
    });

    // 3. RENDER DES BOUTONS D'ACTION (Comparer / Effacer tout)
    var $compareButton = $(".comparison_wrapper .comparison_header_actions .btn");
    var $compareButtonMobile = $(".comparison_wrapper .btn.mobile_only");
    var $deleteAllButton = $(".delete_all_comparisons");

    if (!this.isMobile()) {
      // Desktop
      if (nbTotal >= 2) {
        $compareButton.removeClass("disabled");
      } else {
        $compareButton.addClass("disabled");
      }
    } else {
      // Mobile
      if (nbTotal >= 2) {
        $compareButtonMobile.show();
      } else {
        $compareButtonMobile.hide();
      }

      if (nbTotal > 0) {
        $deleteAllButton.show();
      } else {
        $deleteAllButton.hide();
      }
    }

    // 4. RENDER DE LA VISIBILITÉ DU COMPARATEUR
    if (nbTotal > 0) {
      $(".comparison_wrapper").addClass("active");
    } else {
      $(".comparison_wrapper").removeClass("active");
    }
  }

  // Remplir un slot avec les données d'un véhicule
  populateSlot($slot, vehicleData) {
    $slot.removeClass("empty");

    // Cloner le template depuis la Blade
    var $template = $(".comparison_vehicle_template .comparison_vehicle").clone();

    // Remplir les données du véhicule
    $template.find(".remove_from_comparison").attr("data-vehicle-id", vehicleData.id);
    $template.find(".vehicle_name").text(vehicleData.name);
    $template.find(".vehicle_specs").text(vehicleData.specs);

    if (vehicleData.image) {
      $template.find(".vehicle_image").attr("src", vehicleData.image).attr("alt", vehicleData.name);
    } else {
      $template.find(".vehicle_image").hide();
    }

    // Ajouter l'attribut data-vehicle-id au slot
    $slot.attr("data-vehicle-id", vehicleData.id);

    $slot.html($template);
  }

  // Initialisation : synchroniser l'état des boutons de comparaison au chargement
  initializeComparisonState() {
    // Render le DOM initial depuis le state (vide au départ)
    this.renderDOM();
  }

  // Initialisation des événements
  initEventListeners() {
    const self = this;

    // Ajout / Suppression au comparateur (avec debounce first)
    $(document).on("click", ".product_card .compare_wrapper", function (e) {
      e.preventDefault();

      // DEBOUNCE FIRST : bloquer si une action est en cours
      if (!self.canPerformAction()) {
        return;
      }
      self.blockActions();

      var $that = $(this);
      var vehicleId = String($that.parents(".product_card").first().data("id"));
      var isActive = self.hasVehicle(vehicleId);

      if (isActive) {
        // Supprimer du comparateur
        var result = self.removeVehicle(vehicleId);
        if (result.success && window.updateComparisonCounter) {
          window.updateComparisonCounter();
        }
      } else {
        // Ajouter au comparateur
        var maxLimit = self.getMaxVehiclesLimit();

        // Vérifier si on peut ajouter selon la limite actuelle
        if (self.comparisonState.length >= maxLimit) {
          var maxText = self.isTablet() ? "2 vans" : "3 vans";
          // Afficher notification de comparateur plein
          if (window.showNotification) {
            window.showNotification(`Désolé, vous ne pouvez comparer que ${maxText} à la fois`, { type: "error" });
          }
          return;
        }

        var result = self.addVehicle(vehicleId);
        if (result.success && window.updateComparisonCounter) {
          window.updateComparisonCounter();
        } else if (result.reason === "full") {
          var maxText = self.isTablet() ? "2 vans" : "3 vans";
          if (window.showNotification) {
            window.showNotification(`Désolé, vous ne pouvez comparer que ${maxText} à la fois`, { type: "error" });
          }
        }
      }
    });

    // Gestionnaire pour supprimer un véhicule depuis le slot du comparateur (avec debounce first)
    $(document).on("click", ".remove_from_comparison", function (e) {
      e.preventDefault();

      // DEBOUNCE FIRST : bloquer si une action est en cours
      if (!self.canPerformAction()) {
        return;
      }
      self.blockActions();

      var vehicleId = String($(this).data("vehicle-id"));
      var result = self.removeVehicle(vehicleId);

      if (result.success && window.updateComparisonCounter) {
        window.updateComparisonCounter();
      }
    });

    // Gestionnaire pour "Effacer tout" (avec debounce first)
    $(document).on("click", ".delete_all_comparisons", function (e) {
      e.preventDefault();

      // DEBOUNCE FIRST : bloquer si une action est en cours
      if (!self.canPerformAction()) {
        return;
      }
      self.blockActions();

      // Vider le comparateur
      self.clearVehicles();

      if (window.updateComparisonCounter) {
        window.updateComparisonCounter();
      }
    });

    // Gestionnaire pour fermer et vider le comparateur en mobile (avec debounce first)
    $(document).on("click", ".close_comparison", function (e) {
      e.preventDefault();

      // DEBOUNCE FIRST : bloquer si une action est en cours
      if (!self.canPerformAction()) {
        return;
      }
      self.blockActions();

      // Vérifier si on est en mobile
      if (self.isMobile()) {
        // Vider le comparateur
        self.clearVehicles();

        // Fermer le module de comparaison
        $(".comparison_wrapper").removeClass("active");

        if (window.updateComparisonCounter) {
          window.updateComparisonCounter();
        }
      }
    });

    // Afficher/masquer le comparateur selon la visibilité de .products_list_wrapper au scroll
    $(window).on("scroll.comparison", function () {
      var $productsList = $(".products_list_wrapper");
      if (!$productsList.length || self.comparisonState.length === 0) {
        return;
      }

      var rect = $productsList[0].getBoundingClientRect();
      var isVisible = rect.bottom > 500 && rect.top < window.innerHeight;

      if (isVisible) {
        $(".comparison_wrapper").addClass("active");
      } else {
        $(".comparison_wrapper").removeClass("active");
      }
    });
  }

  // Charger les produits de comparaison dans la modal
  async loadComparisonModal() {
    const modalWrapper = document.querySelector("#modal_compare_wrapper");

    if (!modalWrapper) {
      return;
    }

    // Vider le contenu de la modal
    modalWrapper.innerHTML = '<div class="loading">Chargement...</div>';

    if (this.productHandles.length === 0) {
      modalWrapper.innerHTML = '<div class="no_products">Aucun produit à comparer</div>';
      return;
    }

    // Créer un conteneur pour les produits
    modalWrapper.innerHTML = '<div class="compare_products_grid"></div>';
    const gridWrapper = modalWrapper.querySelector(".compare_products_grid");

    // Charger chaque produit
    for (const productHandle of this.productHandles) {
      try {
        const response = await fetch(`/products/${productHandle}?section_id=compare-renderer`);
        const html = await response.text();

        // Parser le HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const product = doc.querySelector("compare-item");

        if (!product) {
          continue;
        }

        gridWrapper.appendChild(product);
      } catch (error) {
        console.error("Erreur lors du chargement du produit:", productHandle, error);
      }
    }
  }

  // Gestionnaire de redimensionnement pour adapter l'interface mobile/desktop
  initResizeHandler() {
    const self = this;
    $(window).on("resize", function () {
      // Appliquer la limite selon la nouvelle taille d'écran
      var result = self.enforceLimit();

      // Mettre à jour le compteur si des véhicules ont été supprimés
      if (result.removedVehicles && result.removedVehicles.length > 0) {
        if (window.updateComparisonCounter) {
          window.updateComparisonCounter();
        }
      } else {
        // Même sans suppression, re-render pour ajuster l'affichage
        self.renderDOM();
      }
    });
  }
}

customElements.define("comparison-module", Comparison);

// Créer une instance globale pour accès depuis d'autres modules
var comparisonInstance = null;

// Comparison List - Élément personnalisé pour la liste des produits dans la modal de comparaison
if (!customElements.get("comparison-list")) {
  class ComparisonList extends HTMLElement {
    constructor() {
      super();

      this.comparisonModule = document.querySelector("comparison-module");
      this.productHandles = this.comparisonModule.productHandles;
      this.resizeHandler = null;
    }

    connectedCallback() {
      this.loadComparisonList();
      this.initResizeHandler();
    }

    disconnectedCallback() {
      // Nettoyer le gestionnaire de redimensionnement
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
      }
    }

    // Charger les produits de comparaison dans la modal
    async loadComparisonList() {
      const modalWrapper = this.querySelector("#modal_compare_wrapper");

      if (!modalWrapper) {
        return;
      }

      // Vider le contenu de la modal
      modalWrapper.innerHTML = '<div class="loading">Chargement...</div>';

      if (this.productHandles.length === 0) {
        modalWrapper.innerHTML = '<div class="no_products">Aucun produit à comparer</div>';
        return;
      }

      // Créer un conteneur pour les produits
      modalWrapper.innerHTML = '<div class="compare_products_grid"></div>';
      const gridWrapper = modalWrapper.querySelector(".compare_products_grid");

      // Charger chaque produit
      for (const productHandle of this.productHandles) {
        try {
          const response = await fetch(`/products/${productHandle}?section_id=compare-renderer`);
          const html = await response.text();

          // Parser le HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const product = doc.querySelector("compare-item");

          if (!product) {
            continue;
          }

          gridWrapper.appendChild(product);
        } catch (error) {
          console.error("Erreur lors du chargement du produit:", productHandle, error);
        }
      }

      // Égaliser les hauteurs des titres après le chargement de tous les produits
      requestAnimationFrame(() => {
        this.equalizeTitleHeights();
      });

      // Construire et insérer le bloc sticky-details
      this.buildStickyDetails(modalWrapper, gridWrapper);
    }

    // Construire le bloc sticky-details à partir des compare-items chargés
    buildStickyDetails(modalWrapper, gridWrapper) {
      const existingStickyDetails = modalWrapper.querySelector(".sticky-details");
      if (existingStickyDetails) {
        existingStickyDetails.remove();
      }

      const stickyDetails = document.createElement("div");
      stickyDetails.className = "sticky-details";

      const compareItems = gridWrapper.querySelectorAll("compare-item");
      compareItems.forEach((compareItem) => {
        const vehicleInfos = compareItem.querySelector(".vehicle_infos");
        if (!vehicleInfos) return;

        const titleEl = vehicleInfos.querySelector(".h4");
        const subtitleEl = vehicleInfos.querySelector("a > div > p:not(.h4)");
        const modalOpener = vehicleInfos.querySelector("modal-opener");

        const item = document.createElement("div");
        item.className = "sticky-details-item";

        const textDiv = document.createElement("div");
        if (titleEl) {
          const p = document.createElement("p");
          p.className = "h4";
          p.textContent = titleEl.textContent.trim();
          textDiv.appendChild(p);
        }
        if (subtitleEl) {
          const p = document.createElement("p");
          p.textContent = subtitleEl.textContent.trim();
          textDiv.appendChild(p);
        }
        item.appendChild(textDiv);

        if (modalOpener) {
          item.appendChild(modalOpener.cloneNode(true));
        }

        stickyDetails.appendChild(item);
      });

      modalWrapper.insertBefore(stickyDetails, gridWrapper);

      // Écouter le scroll de la modal pour afficher/masquer le sticky-details (mobile uniquement)
      const modalContent = this.closest(".modal_content");
      if (modalContent) {
        const onScroll = () => {
          if (window.innerWidth > 769) return;
          if (modalContent.scrollTop > 200) {
            stickyDetails.classList.add("active");
          } else {
            stickyDetails.classList.remove("active");
          }
        };
        modalContent.removeEventListener("scroll", modalContent._stickyScrollHandler);
        modalContent._stickyScrollHandler = onScroll;
        modalContent.addEventListener("scroll", onScroll);
      }
    }

    // Égaliser les hauteurs des titres h4 en mobile
    equalizeTitleHeights() {
      // Récupérer TOUS les h4 de TOUS les compare-items
      const allTitles = this.querySelectorAll("compare-item .vehicle_infos h4");

      if (allTitles.length === 0) {
        return;
      }

      // En desktop, réinitialiser les hauteurs
      allTitles.forEach((title) => {
        title.style.height = "auto";
      });

      // Réinitialiser les hauteurs pour calculer la hauteur naturelle
      allTitles.forEach((title) => {
        title.style.height = "auto";
      });

      // Calculer la hauteur maximale
      let maxHeight = 0;
      allTitles.forEach((title) => {
        const height = title.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });

      // Appliquer la hauteur maximale à tous les h4
      allTitles.forEach((title) => {
        title.style.height = `${maxHeight}px`;
      });
    }

    // Initialiser le gestionnaire de redimensionnement
    initResizeHandler() {
      let resizeTimeout;
      this.resizeHandler = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.equalizeTitleHeights();
        }, 150);
      };
      window.addEventListener("resize", this.resizeHandler);
    }
  }
  customElements.define("comparison-list", ComparisonList);
}

// Compare Item - Élément personnalisé pour un produit dans la modal de comparaison
if (!customElements.get("compare-item")) {
  class CompareItem extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // L'égalisation des hauteurs est gérée par ComparisonList
      // après le chargement de tous les produits
    }
  }
  customElements.define("compare-item", CompareItem);
}

// Modal opener
class ModalOpener extends HTMLElement {
  constructor() {
    super();
    this.modalBaseUrl = null;
    this.section = null;
    this.originSectionId = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initEventListeners();
  }

  initEventListeners() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.openModal();
    });
  }

  openModal() {
    const modalBaseUrl = this.getAttribute("data-modal-base-url");
    const section = this.getAttribute("data-section");
    const modalWrapper = document.querySelector("#modal_wrapper");
    const activeModal = modalWrapper.querySelector(".modal.active");
    let showReturnButton = false;

    // Si on a déjà une modal ouverte, on récupère l'ID du parent de class "shopify-section"
    if (activeModal) {
      const sectionElement = modalWrapper.querySelector("[data-section-id]");
      if (sectionElement) {
        this.originSectionId = sectionElement.getAttribute("data-section-id");
        showReturnButton = true;
      }
    } else {
      this.originSectionId = null;
      showReturnButton = false;
    }

    if (modalBaseUrl && section) {
      fetch(`${modalBaseUrl}?section_id=${section}`)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");
          const modalContent = doc.querySelector(".shopify-section").innerHTML;
          modalWrapper.innerHTML = modalContent;

          if (showReturnButton && modalWrapper.querySelector("form-lead")) {
            const returnButton = modalWrapper.querySelector(".modal_return");
            if (returnButton) {
              returnButton.setAttribute("data-section", this.originSectionId);
              // On l'affiche
              returnButton.style.display = "block";
            }
          }

          const modalElement = modalWrapper.querySelector(".modal");

          // Opener placé dans une modal persistante (section "Modal personnalisée") :
          // celle-ci n'est pas dans #modal_wrapper, on la referme une fois la
          // nouvelle modal chargée pour ne pas empiler les deux. Fait avant
          // lockPageScroll, car closeModal déverrouille le scroll.
          const parentModal = this.closest(".modal[data-modal-persistent].active");
          if (parentModal) {
            parentModal.closest("modal-content").closeModal();
          }

          lockPageScroll();

          // Activer la modal avec une petite animation
          setTimeout(() => {
            modalElement.classList.add("active");
            refreshModalTruncates(modalElement);

            // Focus sur le premier élément focusable (accessibilité)
            const focusableElements = modalElement.querySelectorAll('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');

            // Focus le premier élément s'il existe
            if (focusableElements.length > 0) {
              focusableElements[0].focus();
            }
          }, 10);
        });
    }
  }
}

// Enregistrer le Custom Element
customElements.define("modal-opener", ModalOpener);

// Gestion des modales
class ModalContent extends HTMLElement {
  constructor() {
    super();
    this.modalCloseButton = this.querySelector(".close");
    this.modalOverlay = this.querySelector(".modal_overlay");
    this.modal = this.querySelector(".modal");
  }

  connectedCallback() {
    this.init();
    this.autoOpen();
  }

  disconnectedCallback() {
    clearTimeout(this.autoOpenTimeout);
  }

  init() {
    this.initEventListeners();
  }

  /**
   * Ouverture automatique après le chargement de la page (mode "Automatiquement
   * au chargement de la page" de la section "Modal personnalisée"), sauf si la
   * modal a déjà été fermée pendant la session.
   * La valeur de data-modal-auto-open est le délai d'attente, en secondes.
   * Ignorée dans l'éditeur de thème : la modal y est affichée à la sélection
   * de la section, sinon elle se rouvrirait à chaque modification d'un réglage.
   */
  autoOpen() {
    if (!this.modal.hasAttribute("data-modal-auto-open")) {
      return;
    }

    if (isModalDismissed(this.modal) || (window.Shopify && window.Shopify.designMode)) {
      return;
    }

    const delay = parseFloat(this.modal.getAttribute("data-modal-auto-open")) || 0;

    this.autoOpenTimeout = setTimeout(() => {
      // Nouvelle vérification : la modal a pu être ouverte puis fermée
      // via un déclencheur pendant le délai d'attente
      if (!isModalDismissed(this.modal) && !this.modal.classList.contains("active")) {
        activateModal(this.modal);
      }
    }, delay * 1000);
  }

  initEventListeners() {
    // Fermer la modal avec le bouton de fermeture ou au click sur l'overlay
    this.modalCloseButton.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeModal();
    });
    this.modalOverlay.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.closeModal();
    });

    // Fermer avec la touche Escape
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.modal.classList.contains("active")) {
        this.closeModal();
      }
    });

    // Soumettre un formulaire de la modal vaut fermeture : le POST recharge la
    // page, et la modal ne doit pas se rouvrir derrière (cas du formulaire
    // newsletter de la section "Modal personnalisée").
    // L'événement submit remonte, donc un seul écouteur sur .modal suffit, et il
    // ne se déclenche pas si la validation HTML du navigateur bloque l'envoi.
    // dismissModal ne fait rien sur les modales sans data-modal-session-key.
    this.modal.addEventListener("submit", () => {
      dismissModal(this.modal);
    });

    // Pas de stopPropagation sur .modal : l'overlay est un frère de
    // .modal_content, pas un ancêtre, donc un clic dans le contenu ne déclenche
    // jamais son listener de fermeture. Bloquer la propagation empêchait en
    // revanche les clics d'atteindre document, et cassait tous les handlers
    // délégués du thème à l'intérieur des modales (.show_hidden_content,
    // [data-modal-trigger], [data-drawer]...).
  }

  closeModal() {
    this.modal.classList.remove("active");
    unlockPageScroll();

    // Mémoriser la fermeture pour ne plus réafficher la modal pendant la session
    dismissModal(this.modal);

    // Les modales persistantes (rendues directement dans la page par une section)
    // restent dans le DOM pour pouvoir être réouvertes sans nouvel appel réseau
    if (this.modal.hasAttribute("data-modal-persistent")) {
      return;
    }

    this.remove();
  }
}

// Enregistrer le Custom Element
customElements.define("modal-content", ModalContent);

// Modales portant data-modal-session-key : la fermeture est mémorisée en session
// pour ne plus les réafficher jusqu'à la prochaine session de navigation.
// L'éditeur de thème est ignoré, sinon la modal deviendrait impossible à éditer une fois fermée.
function isModalDismissed(modal) {
  const sessionKey = modal.getAttribute("data-modal-session-key");

  if (!sessionKey || (window.Shopify && window.Shopify.designMode)) {
    return false;
  }

  try {
    return sessionStorage.getItem(sessionKey) === "true";
  } catch (e) {
    return false;
  }
}

function dismissModal(modal) {
  const sessionKey = modal.getAttribute("data-modal-session-key");

  if (!sessionKey || (window.Shopify && window.Shopify.designMode)) {
    return;
  }

  try {
    sessionStorage.setItem(sessionKey, "true");
  } catch (e) {
    // sessionStorage indisponible (navigation privée, cookies bloqués) : on ne mémorise rien
  }
}

// Recalcule le troncage des textes d'une modal qui vient d'être affichée
function refreshModalTruncates(modal) {
  modal.querySelectorAll("text-truncate").forEach((element) => {
    if (typeof element.refresh === "function") {
      element.refresh();
    }
  });
}

// Affiche une modal déjà présente dans le DOM
function activateModal(modal, focusFirstElement = true) {
  lockPageScroll();
  modal.classList.add("active");
  refreshModalTruncates(modal);

  if (!focusFirstElement) {
    return;
  }

  // Focus sur le premier élément focusable (accessibilité)
  const focusableElement = modal.querySelector('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');

  if (focusableElement) {
    setTimeout(() => focusableElement.focus(), 10);
  }
}

// Ouverture des modales persistantes rendues dans la page (section "Modal personnalisée")
function openPersistentModal(handle) {
  if (!handle) {
    return false;
  }

  // L'identifiant est passé au filtre Liquid "handle" côté section : on tolère
  // donc la casse et les espaces dans la valeur de data-modal-trigger
  const handles = [handle, handle.trim().toLowerCase().replace(/[\s_]+/g, "-")];
  let modal = null;

  for (const value of handles) {
    modal = document.getElementById(`modal-${value}`) || document.getElementById(value);

    if (modal) {
      break;
    }
  }

  if (!modal || !modal.classList.contains("modal")) {
    return false;
  }

  // La modal existe mais a déjà été fermée pendant cette session : on ne la rouvre pas,
  // tout en signalant que le déclencheur a bien été pris en charge
  if (isModalDismissed(modal)) {
    return true;
  }

  activateModal(modal);

  return true;
}

// N'importe quel élément portant data-modal-trigger="<identifiant>" ouvre la modal correspondante
document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-modal-trigger]");

  if (!trigger) {
    return;
  }

  if (openPersistentModal(trigger.getAttribute("data-modal-trigger"))) {
    e.preventDefault();
  }
});

// Dans l'éditeur de thème, afficher la modal quand la section est sélectionnée
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener("shopify:section:select", (e) => {
    const modal = e.target.querySelector(".modal[data-modal-persistent]");

    if (modal) {
      activateModal(modal, false);
    }
  });

  document.addEventListener("shopify:section:deselect", (e) => {
    const modal = e.target.querySelector(".modal[data-modal-persistent]");

    if (modal) {
      modal.classList.remove("active");
      unlockPageScroll();
    }
  });
}

/**
 * Drawer Manager
 * Gère l'ouverture et la fermeture des drawers (panneaux latéraux)
 */
class DrawerManager extends HTMLElement {
  constructor() {
    super();

    // Drawer actuellement ouvert
    this.activeDrawer = null;

    // Timeout pour débloquer le scroll (évite les conflits lors de l'ouverture successive de drawers)
    this.scrollUnlockTimeout = null;
  }

  connectedCallback() {
    this.init();

    // Rendre l'instance accessible globalement pour pouvoir l'utiliser dans d'autres scripts
    if (typeof window !== "undefined") {
      window.drawerManagerInstance = this;
    }
  }

  init() {
    const self = this;

    // Ouvrir les drawers via data-drawer
    document.addEventListener("click", function (e) {
      const target = e.target.closest("[data-drawer]");
      if (target) {
        e.preventDefault();
        const drawerId = target.getAttribute("data-drawer");
        const drawerDataAttr = target.getAttribute("data-drawer-data");
        const drawerData = drawerDataAttr ? JSON.parse(drawerDataAttr) : {};
        self.openDrawer(drawerId, drawerData);
      }
    });

    // Fermer les drawers via data-drawer-close
    document.addEventListener("click", function (e) {
      const target = e.target.closest("[data-drawer-close]");
      if (target) {
        e.preventDefault();
        self.closeDrawer();
        return;
      }
    });

    // Fermer le drawer avec la touche Escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && self.activeDrawer) {
        self.closeDrawer();
      }
    });

    // Fermer le drawer au clic sur l'overlay ou le conteneur drawer
    document.addEventListener("click", function (e) {
      if (!self.activeDrawer) {
        return;
      }

      // Ne pas fermer si le clic est à l'intérieur du contenu du drawer
      const drawerContent = e.target.closest(".drawer_content");
      if (drawerContent && self.activeDrawer.contains(drawerContent)) {
        return;
      }

      // Fermer si le clic est sur l'overlay ou directement sur le conteneur du drawer
      if (e.target === self.activeDrawer || e.target.classList.contains("drawer_overlay")) {
        self.closeDrawer();
      }
    });
  }

  /**
   * Ouvre un drawer par son ID
   * @param {string} drawerId - ID du drawer à ouvrir
   * @param {object} data - Données optionnelles à passer au drawer
   */
  openDrawer(drawerId, data = {}) {
    const drawer = document.getElementById(drawerId);

    if (!drawer) {
      return;
    }

    // Fermer tout drawer déjà ouvert
    if (this.activeDrawer) {
      this.closeDrawer();
    }

    // Annuler le timeout de déblocage du scroll s'il existe
    if (this.scrollUnlockTimeout) {
      clearTimeout(this.scrollUnlockTimeout);
      this.scrollUnlockTimeout = null;
    }

    lockPageScroll();

    // Activer le drawer avec une petite animation
    setTimeout(() => {
      drawer.classList.add("active");
      this.activeDrawer = drawer;
    }, 10);
  }

  /**
   * Ferme le drawer actif
   */
  closeDrawer() {
    if (!this.activeDrawer) {
      return;
    }

    const drawerId = this.activeDrawer.id;

    // Retirer la classe active
    this.activeDrawer.classList.remove("active");

    // Trigger un event personnalisé pour notifier la fermeture
    const event = new CustomEvent("drawer:closed", { detail: { drawerId } });
    this.activeDrawer.dispatchEvent(event);

    // Réinitialiser activeDrawer immédiatement
    this.activeDrawer = null;

    // Débloquer le scroll du body seulement si aucune modal n'est ouverte
    unlockPageScroll();
  }

  /**
   * Vérifie si un drawer est actuellement ouvert
   * @returns {boolean}
   */
  isDrawerOpen() {
    return this.activeDrawer !== null;
  }

  /**
   * Retourne l'ID du drawer actif
   * @returns {string|null}
   */
  getActiveDrawerId() {
    return this.activeDrawer ? this.activeDrawer.id : null;
  }
}

// Enregistrer le Custom Element
customElements.define("drawer-manager", DrawerManager);

/**
 * Notifications
 */

class CustomNotification extends HTMLElement {
  constructor() {
    super();

    // Variables d'instance pour la gestion des timers et états
    this.notifTimeout = null;
    this.isPaused = false;
    this.progressBar = null;
    this.isVisible = false;
    this.duration = 5000; // 5 secondes par défaut
    this.startTime = null; // Temps de début de l'animation
    this.remainingTime = null; // Temps restant lors de la pause

    // Initialiser le composant
    this.init();
  }

  init() {
    this.bindEvents();

    // Trouver la barre de progression dans le contenu existant
    this.progressBar = this.querySelector(".progress-bar");
  }

  bindEvents() {
    // Pause/resume sur hover
    this.addEventListener("mouseenter", this.pauseTimer.bind(this));
    this.addEventListener("mouseleave", this.resumeTimer.bind(this));

    // Fermeture à la fin de l'animation
    if (this.progressBar) {
      this.progressBar.addEventListener("animationend", this.hide.bind(this));
    }
  }

  /**
   * Affiche la notification avec le message spécifié
   * @param {string} message - Le texte à afficher
   * @param {Object} options - Options d'affichage
   * @param {number} options.duration - Durée d'affichage en ms (optionnel, défaut: 5000)
   * @param {string} options.type - Type de notification: 'error', 'success', etc. (optionnel)
   */
  show(message, options = {}) {
    if (this.isVisible) {
      this.hide(); // Masquer la notification actuelle avant d'en afficher une nouvelle
    }

    // Configuration
    this.duration = options.duration || 5000;

    // Mise à jour du contenu en utilisant le template existant
    const textElement = this.querySelector(".notification-text");

    if (textElement) {
      textElement.innerHTML = message;
    }

    // S'assurer qu'on a la barre de progression
    if (!this.progressBar) {
      this.progressBar = this.querySelector(".progress-bar");
    }

    // Réinitialiser l'état et les classes
    this.isPaused = false;
    this.classList.remove("active", "error", "success");

    // Ajouter la classe de type si spécifiée
    if (options.type) {
      this.classList.add(options.type);
    }

    if (this.progressBar) {
      this.progressBar.style.cssText = `
        width: 0%;
        animation: none;
      `;
    }

    // Forcer un reflow pour s'assurer que les styles sont appliqués
    void this.offsetWidth;

    // Afficher la notification
    this.classList.add("active");

    if (this.progressBar) {
      this.progressBar.style.animation = `notifProgressBar ${this.duration}ms linear forwards`;
      this.progressBar.style.animationPlayState = "running";
    }

    this.isVisible = true;
    this.startTime = Date.now();
    this.remainingTime = this.duration;

    // Timeout de sécurité (duration + 1 seconde de marge)
    this.notifTimeout = setTimeout(() => {
      this.hide();
    }, this.duration + 1000);
  }

  /**
   * Masque la notification
   */
  hide() {
    if (!this.isVisible) return;

    this.classList.remove("active");
    this.isVisible = false;
    this.isPaused = false;
    this.startTime = null;
    this.remainingTime = null;

    // Nettoyer les timers
    if (this.notifTimeout) {
      clearTimeout(this.notifTimeout);
      this.notifTimeout = null;
    }

    // Réinitialiser la barre de progression
    if (this.progressBar) {
      this.progressBar.style.cssText = `
        width: 0%;
        animation: none;
        animation-play-state: paused;
      `;
    }

    // Émettre un événement pour notifier qu'elle est fermée
    this.dispatchEvent(
      new CustomEvent("notification-closed", {
        bubbles: true,
      }),
    );
  }

  /**
   * Met en pause le timer de fermeture automatique
   */
  pauseTimer() {
    if (!this.isVisible || this.isPaused) return;

    this.isPaused = true;

    // Calculer le temps restant
    const elapsed = Date.now() - this.startTime;
    this.remainingTime = Math.max(0, this.duration - elapsed);

    // Annuler le timeout actuel
    if (this.notifTimeout) {
      clearTimeout(this.notifTimeout);
      this.notifTimeout = null;
    }

    // Mettre l'animation en pause
    if (this.progressBar) {
      this.progressBar.style.animationPlayState = "paused";
    }
  }

  /**
   * Reprend le timer de fermeture automatique
   */
  resumeTimer() {
    if (!this.isVisible || !this.isPaused) return;

    this.isPaused = false;

    // Mettre à jour le temps de début pour le calcul futur
    this.startTime = Date.now();

    // Reprendre l'animation
    if (this.progressBar) {
      this.progressBar.style.animationPlayState = "running";
    }

    // Recréer le timeout avec le temps restant + marge de sécurité
    this.notifTimeout = setTimeout(() => {
      this.hide();
    }, this.remainingTime + 1000);
  }

  // Lifecycle callbacks
  connectedCallback() {
    // Le composant est ajouté au DOM - réinitialiser la logique
    this.init();

    // Si la notification existe déjà avec la classe "active" (cas des notifications Liquid),
    // déclencher automatiquement l'animation et le timer de fermeture
    // puis supprimer le composant de la DOM après l'animation pour éviter les problèmes de rechargement de la page
    if (this.classList.contains("active")) {
      const textElement = this.querySelector(".notification-text");
      const message = textElement ? textElement.innerHTML : "";

      // Déterminer le type de notification
      let type = "success";
      if (this.classList.contains("error")) {
        type = "error";
      }

      // Déclencher l'animation
      setTimeout(() => {
        this.show(message, { type, duration: 5000 });
      }, 100);
    }
  }

  disconnectedCallback() {
    // Nettoyer lors de la suppression du DOM
    if (this.notifTimeout) {
      clearTimeout(this.notifTimeout);
    }
  }
}

// Enregistrer le web component
customElements.define("custom-notification", CustomNotification);

// Gestionnaire de notifications multiples
const NotificationManager = {
  maxNotifications: 4,
  wrapper: null,

  init() {
    this.wrapper = document.getElementById("notifications-wrapper");

    if (!this.wrapper) {
      console.warn("Wrapper de notification non trouvé dans le DOM");
    }
  },

  // Icônes pour les différents types de notifications
  icons: {
    success: `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.4118 14.6221V25.6188C10.4118 25.9834 10.2692 26.333 10.0155 26.5908C9.76177 26.8486 9.41765 26.9934 9.05882 26.9934H6.35294C5.99412 26.9934 5.64999 26.8486 5.39627 26.5908C5.14254 26.333 5 25.9834 5 25.6188V15.9967C5 15.6321 5.14254 15.2825 5.39627 15.0247C5.64999 14.7669 5.99412 14.6221 6.35294 14.6221H10.4118ZM10.4118 14.6221C11.8471 14.6221 13.2236 14.0428 14.2385 13.0117C15.2534 11.9805 15.8235 10.582 15.8235 9.12376V7.74917C15.8235 7.02005 16.1086 6.32078 16.6161 5.80521C17.1235 5.28964 17.8118 5 18.5294 5C19.2471 5 19.9353 5.28964 20.4428 5.80521C20.9502 6.32078 21.2353 7.02005 21.2353 7.74917V14.6221H25.2941C26.0118 14.6221 26.7 14.9117 27.2075 15.4273C27.7149 15.9429 28 16.6422 28 17.3713L26.6471 24.2442C26.4525 25.0875 26.0834 25.8116 25.5954 26.3074C25.1073 26.8033 24.5268 27.044 23.9412 26.9934H14.4706C13.3941 26.9934 12.3617 26.5589 11.6006 25.7856C10.8394 25.0122 10.4118 23.9633 10.4118 22.8696" stroke="#5C5622" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
    error: `<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.4064 25C24.6825 25 24.9064 24.7761 24.9064 24.5C24.9064 24.2239 24.6825 24 24.4064 24V24.5V25ZM0.5 24.5L9.26256e-05 24.4904C-0.00249177 24.6246 0.0490308 24.7543 0.14306 24.8501C0.23709 24.946 0.365724 25 0.5 25V24.5ZM3.40488 20.6176L3.37028 21.1164C3.59771 21.1322 3.80701 20.9922 3.87917 20.7759L3.40488 20.6176ZM6.34901 18.8922L6.18321 19.3639C6.32113 19.4123 6.47336 19.398 6.59983 19.3247C6.7263 19.2514 6.81434 19.1264 6.84077 18.9826L6.34901 18.8922ZM10.8634 17.9902L10.3967 18.1698C10.4497 18.3074 10.5606 18.4145 10.6999 18.4627C10.8392 18.5109 10.9926 18.4952 11.1192 18.4198L10.8634 17.9902ZM13.6505 19.049L13.1754 19.2048C13.2176 19.3336 13.3104 19.4398 13.4324 19.4989C13.5544 19.5581 13.6951 19.5651 13.8224 19.5185L13.6505 19.049ZM16.5161 20.7745L16.0255 20.8712C16.0761 21.1279 16.3161 21.3022 16.5758 21.2709L16.5161 20.7745ZM19.7088 24.5521C19.7376 24.8268 19.9836 25.0261 20.2582 24.9973C20.5329 24.9685 20.7321 24.7225 20.7033 24.4479L20.2061 24.5L19.7088 24.5521ZM8.28986 16.6428C8.17383 16.8934 8.2829 17.1906 8.53348 17.3067C8.78406 17.4227 9.08126 17.3136 9.1973 17.063L8.74358 16.8529L8.28986 16.6428ZM15.888 7.48039L16.1437 7.0507C15.9641 6.94383 15.7369 6.95996 15.5742 7.09114L15.888 7.48039ZM21.2267 10.6569L21.7218 10.7266C21.7499 10.5271 21.6555 10.3302 21.4824 10.2272L21.2267 10.6569ZM16.665 20.0048C16.4998 20.2261 16.5453 20.5394 16.7666 20.7046C16.9878 20.8698 17.3011 20.8243 17.4663 20.603L17.0657 20.3039L16.665 20.0048ZM15.8173 7.44924C15.7134 7.70512 15.8367 7.99672 16.0925 8.10056C16.3484 8.2044 16.64 8.08115 16.7439 7.82527L16.2806 7.63726L15.8173 7.44924ZM16.8694 6.18627L17.3327 6.37429C17.3394 6.35777 17.3452 6.3409 17.3501 6.32376L16.8694 6.18627ZM21.3837 8.34314L21.1229 8.76974C21.1351 8.77717 21.1476 8.78408 21.1603 8.79044L21.3837 8.34314ZM20.5549 10.0784C20.387 10.2977 20.4287 10.6115 20.648 10.7794C20.8673 10.9472 21.1811 10.9055 21.349 10.6863L20.9519 10.3824L20.5549 10.0784ZM13.9884 8.9983C14.112 9.24524 14.4124 9.34523 14.6594 9.22163C14.9063 9.09804 15.0063 8.79766 14.8827 8.55072L14.4356 8.77451L13.9884 8.9983ZM12.9831 5.87255L13.4303 5.64876C13.4218 5.63195 13.4125 5.61562 13.4022 5.59986L12.9831 5.87255ZM10.039 10.2255L10.4973 10.0257C10.4938 10.0176 10.4901 10.0096 10.4861 10.0017L10.039 10.2255ZM10.6405 12.8567C10.7509 13.1098 11.0456 13.2256 11.2987 13.1152C11.5518 13.0049 11.6676 12.7102 11.5572 12.4571L11.0989 12.6569L10.6405 12.8567ZM20.7556 12.3922C20.4795 12.3922 20.2556 12.616 20.2556 12.8922C20.2556 13.1683 20.4795 13.3922 20.7556 13.3922V12.8922V12.3922ZM23.9353 12.8922V13.3922C24.2115 13.3922 24.4353 13.1683 24.4353 12.8922H23.9353ZM21.8548 17.4412V16.9412C21.8415 16.9412 21.8282 16.9417 21.815 16.9428L21.8548 17.4412ZM18.8708 17.1781C18.5956 17.2001 18.3902 17.441 18.4122 17.7163C18.4342 17.9916 18.6752 18.1969 18.9505 18.1749L18.9107 17.6765L18.8708 17.1781ZM20.4034 0.808346C20.5737 0.590966 20.5355 0.276693 20.3181 0.106398C20.1008 -0.063897 19.7865 -0.0257267 19.6162 0.191654L20.0098 0.5L20.4034 0.808346ZM19.2529 5.28742C19.1247 5.53198 19.219 5.83419 19.4636 5.96243C19.7081 6.09066 20.0103 5.99636 20.1386 5.75179L19.6958 5.51961L19.2529 5.28742ZM22.8765 2.02403C23.0468 1.80665 23.0086 1.49238 22.7912 1.32208C22.5738 1.15179 22.2596 1.18996 22.0893 1.40734L22.4829 1.71569L22.8765 2.02403ZM21.726 6.50311C21.5978 6.74767 21.6921 7.04988 21.9366 7.17811C22.1812 7.30635 22.4834 7.21204 22.6117 6.96748L22.1688 6.73529L21.726 6.50311ZM9.97228 17.3244C9.95108 17.5997 10.1571 17.8401 10.4324 17.8613C10.7077 17.8825 10.9481 17.6765 10.9693 17.4011L10.4708 17.3627L9.97228 17.3244ZM15.4721 19.0068C15.3188 19.2365 15.3808 19.5469 15.6105 19.7002C15.8402 19.8535 16.1506 19.7916 16.3039 19.5619L15.888 19.2843L15.4721 19.0068ZM24.4064 24.5V24H0.5V24.5V25H24.4064V24.5ZM0.5 24.5C0.999907 24.5096 0.999904 24.5098 0.999902 24.5099C0.999901 24.5099 0.999899 24.5101 0.999898 24.5101C0.999895 24.5102 0.999894 24.5103 0.999895 24.5102C0.999896 24.5102 0.999902 24.5099 0.999914 24.5094C0.99994 24.5084 0.999992 24.5064 1.00008 24.5035C1.00026 24.4977 1.00058 24.4883 1.00112 24.4754C1.00221 24.4497 1.0042 24.4104 1.00771 24.3596C1.01474 24.2577 1.02782 24.1102 1.05188 23.9331C1.10038 23.5761 1.19172 23.1118 1.36075 22.6608C1.53113 22.2061 1.76813 21.7981 2.08817 21.5176C2.3943 21.2493 2.79855 21.0768 3.37028 21.1164L3.40488 20.6176L3.43948 20.1188C2.59803 20.0605 1.93257 20.3242 1.42907 20.7655C0.939471 21.1946 0.626896 21.7694 0.42435 22.3098C0.220459 22.8539 0.115527 23.3969 0.0609795 23.7985C0.0335178 24.0007 0.0183855 24.1703 0.0100793 24.2907C0.0059213 24.351 0.0034599 24.3991 0.00202096 24.4331C0.00130123 24.45 0.000836521 24.4635 0.000543118 24.4731C0.000396401 24.4779 0.00029248 24.4818 0.000220865 24.4847C0.000185072 24.4861 0.000157356 24.4873 0.000136405 24.4883C0.000125945 24.4887 0.000117153 24.4892 0.000109911 24.4895C0.000106305 24.4897 0.000101924 24.4899 0.000100195 24.49C9.62019e-05 24.4902 9.26256e-05 24.4904 0.5 24.5ZM3.40488 20.6176C3.87917 20.7759 3.87911 20.7761 3.87905 20.7763C3.87903 20.7763 3.87898 20.7765 3.87894 20.7766C3.87888 20.7768 3.87883 20.7769 3.87878 20.7771C3.8787 20.7773 3.87867 20.7774 3.87868 20.7774C3.87871 20.7773 3.87894 20.7766 3.87936 20.7754C3.88019 20.773 3.8818 20.7685 3.8842 20.7619C3.88901 20.7488 3.89694 20.7277 3.90809 20.7001C3.93046 20.6447 3.96544 20.5637 4.01368 20.4675C4.11137 20.2729 4.25738 20.0285 4.45403 19.8096C4.65063 19.5907 4.88364 19.4127 5.15477 19.3211C5.4174 19.2324 5.75148 19.2121 6.18321 19.3639L6.34901 18.8922L6.51482 18.4205C5.88666 18.1997 5.32278 18.2088 4.83465 18.3737C4.35503 18.5358 3.98449 18.8358 3.71003 19.1414C3.43562 19.4469 3.24305 19.7737 3.11993 20.019C3.05777 20.1428 3.01178 20.249 2.98079 20.3258C2.96526 20.3643 2.95341 20.3956 2.94511 20.4183C2.94095 20.4296 2.93768 20.4388 2.93526 20.4457C2.93406 20.4492 2.93306 20.4521 2.93229 20.4544C2.9319 20.4555 2.93156 20.4565 2.93128 20.4573C2.93114 20.4578 2.93101 20.4581 2.93089 20.4585C2.93083 20.4586 2.93076 20.4589 2.93073 20.459C2.93066 20.4592 2.93059 20.4594 3.40488 20.6176ZM6.34901 18.8922C6.84077 18.9826 6.84073 18.9828 6.84069 18.983C6.84068 18.9831 6.84064 18.9833 6.84062 18.9834C6.84057 18.9836 6.84053 18.9839 6.8405 18.9841C6.84042 18.9844 6.84037 18.9847 6.84034 18.9849C6.84028 18.9852 6.8403 18.9851 6.84041 18.9846C6.84062 18.9835 6.84118 18.9807 6.84212 18.9764C6.84399 18.9677 6.84737 18.9528 6.8525 18.9326C6.86279 18.8921 6.87997 18.8309 6.90599 18.7559C6.95856 18.6045 7.04424 18.406 7.17578 18.2109C7.431 17.8323 7.84991 17.4706 8.58656 17.4706V16.9706V16.4706C7.43896 16.4706 6.7391 17.0697 6.3466 17.6519C6.15429 17.9371 6.03388 18.219 5.96133 18.4279C5.92479 18.5331 5.89964 18.622 5.88325 18.6865C5.87504 18.7189 5.86899 18.7453 5.86477 18.7648C5.86266 18.7745 5.861 18.7825 5.85976 18.7887C5.85915 18.7918 5.85863 18.7945 5.85821 18.7967C5.85801 18.7977 5.85782 18.7987 5.85766 18.7996C5.85758 18.8 5.85751 18.8004 5.85744 18.8007C5.85741 18.8009 5.85736 18.8012 5.85735 18.8013C5.8573 18.8015 5.85726 18.8017 6.34901 18.8922ZM8.58656 16.9706V17.4706C9.43304 17.4706 9.89207 17.6975 10.128 17.8777C10.2492 17.9703 10.3219 18.0584 10.3616 18.1157C10.3816 18.1445 10.3933 18.1657 10.3987 18.176C10.4013 18.1811 10.4023 18.1835 10.4019 18.1826C10.4018 18.1822 10.4012 18.181 10.4003 18.1788C10.3999 18.1778 10.3994 18.1765 10.3988 18.175C10.3985 18.1743 10.3982 18.1735 10.3978 18.1726C10.3976 18.1722 10.3975 18.1717 10.3973 18.1713C10.3972 18.171 10.3971 18.1707 10.397 18.1706C10.3969 18.1702 10.3967 18.1698 10.8634 17.9902C11.33 17.8105 11.3298 17.8102 11.3297 17.8098C11.3296 17.8097 11.3295 17.8093 11.3294 17.809C11.3292 17.8085 11.329 17.808 11.3287 17.8074C11.3283 17.8063 11.3278 17.8051 11.3274 17.8039C11.3264 17.8014 11.3253 17.7987 11.324 17.7957C11.3215 17.7897 11.3186 17.7828 11.315 17.7749C11.308 17.7591 11.2987 17.7395 11.287 17.7168C11.2634 17.6713 11.2298 17.6129 11.1835 17.5461C11.0908 17.4122 10.9476 17.2454 10.7351 17.0831C10.3037 16.7535 9.62432 16.4706 8.58656 16.4706V16.9706ZM10.8634 17.9902C11.1192 18.4198 11.119 18.4199 11.1188 18.42C11.1188 18.42 11.1186 18.4202 11.1185 18.4202C11.1182 18.4203 11.1181 18.4205 11.1179 18.4205C11.1176 18.4207 11.1174 18.4208 11.1173 18.4209C11.1172 18.421 11.1175 18.4208 11.1182 18.4204C11.1197 18.4195 11.123 18.4176 11.128 18.4149C11.138 18.4094 11.1546 18.4004 11.1771 18.3891C11.2224 18.3663 11.2901 18.3346 11.3741 18.3022C11.5459 18.2358 11.7667 18.1738 11.9935 18.1664C12.2155 18.1592 12.4274 18.2043 12.615 18.3346C12.8021 18.4646 13.0144 18.7138 13.1754 19.2048L13.6505 19.049L14.1256 18.8932C13.9137 18.2469 13.5911 17.7952 13.1857 17.5134C12.7807 17.232 12.3425 17.1545 11.961 17.1669C11.5842 17.1792 11.2481 17.2789 11.0138 17.3694C10.8948 17.4154 10.7972 17.4609 10.7279 17.4957C10.6932 17.5132 10.6652 17.5281 10.6449 17.5393C10.6348 17.5449 10.6265 17.5496 10.6203 17.5532C10.6171 17.555 10.6145 17.5565 10.6124 17.5578C10.6113 17.5584 10.6104 17.5589 10.6096 17.5594C10.6091 17.5596 10.6088 17.5599 10.6084 17.5601C10.6083 17.5602 10.608 17.5603 10.6079 17.5603C10.6077 17.5605 10.6075 17.5606 10.8634 17.9902ZM13.6505 19.049C13.8224 19.5185 13.8222 19.5186 13.822 19.5187C13.8219 19.5187 13.8217 19.5188 13.8216 19.5188C13.8213 19.5189 13.8211 19.519 13.8209 19.5191C13.8206 19.5192 13.8204 19.5193 13.8203 19.5193C13.8201 19.5194 13.8204 19.5192 13.8213 19.5189C13.823 19.5183 13.8268 19.517 13.8326 19.5152C13.8441 19.5114 13.8632 19.5054 13.889 19.4981C13.9408 19.4834 14.0182 19.4639 14.1135 19.447C14.3073 19.4128 14.5575 19.3927 14.8104 19.4345C15.0587 19.4755 15.3005 19.5741 15.5054 19.7723C15.7101 19.9704 15.9134 20.3024 16.0255 20.8712L16.5161 20.7745L17.0066 20.6778C16.8636 19.9525 16.5811 19.4217 16.2007 19.0537C15.8204 18.6857 15.3778 18.5147 14.9734 18.4479C14.5737 18.3818 14.2032 18.4157 13.9394 18.4623C13.8059 18.4859 13.6953 18.5136 13.6163 18.536C13.5767 18.5472 13.5448 18.5572 13.5215 18.5648C13.5099 18.5686 13.5004 18.5718 13.4932 18.5743C13.4896 18.5756 13.4865 18.5766 13.4841 18.5775C13.4829 18.5779 13.4818 18.5783 13.4808 18.5787C13.4804 18.5788 13.48 18.579 13.4796 18.5791C13.4794 18.5792 13.4791 18.5793 13.479 18.5793C13.4787 18.5794 13.4785 18.5795 13.6505 19.049ZM16.5161 20.7745C16.5758 21.2709 16.5755 21.271 16.5753 21.271C16.5752 21.271 16.5749 21.271 16.5748 21.2711C16.5745 21.2711 16.5742 21.2711 16.574 21.2711C16.5735 21.2712 16.5733 21.2712 16.5732 21.2712C16.5731 21.2712 16.5737 21.2712 16.5751 21.271C16.5778 21.2708 16.5834 21.2702 16.5916 21.2696C16.6082 21.2683 16.6354 21.2666 16.6718 21.2655C16.7449 21.2633 16.854 21.2638 16.9879 21.2756C17.2574 21.2994 17.6163 21.3681 17.9829 21.5439C18.6813 21.879 19.5094 22.6505 19.7088 24.5521L20.2061 24.5L20.7033 24.4479C20.471 22.2319 19.454 21.1406 18.4154 20.6423C17.9135 20.4015 17.4308 20.3109 17.0759 20.2795C16.8976 20.2638 16.7488 20.2627 16.642 20.2659C16.5886 20.2675 16.5454 20.2702 16.514 20.2726C16.4983 20.2738 16.4855 20.275 16.4758 20.276C16.471 20.2765 16.4669 20.2769 16.4637 20.2773C16.4621 20.2774 16.4606 20.2776 16.4594 20.2777C16.4588 20.2778 16.4582 20.2779 16.4577 20.2779C16.4575 20.278 16.4571 20.278 16.457 20.278C16.4567 20.2781 16.4563 20.2781 16.5161 20.7745ZM8.74358 16.8529C9.1973 17.063 9.19726 17.0631 9.19724 17.0631C9.19725 17.0631 9.19724 17.0632 9.19725 17.0631C9.19728 17.0631 9.19735 17.0629 9.19745 17.0627C9.19767 17.0622 9.19804 17.0614 9.19858 17.0603C9.19966 17.058 9.20138 17.0543 9.20374 17.0493C9.20847 17.0392 9.21576 17.0238 9.2256 17.0033C9.24527 16.9622 9.2751 16.9006 9.31489 16.8205C9.39447 16.6601 9.5138 16.4256 9.67119 16.1322C9.98609 15.5452 10.4526 14.7241 11.0572 13.7916C12.2695 11.9216 14.0221 9.62699 16.2018 7.86965L15.888 7.48039L15.5742 7.09114C13.2789 8.94164 11.4592 11.3333 10.2181 13.2476C9.59591 14.2073 9.11543 15.0528 8.78999 15.6595C8.6272 15.9629 8.50303 16.2069 8.41914 16.3759C8.3772 16.4604 8.34531 16.5262 8.3237 16.5713C8.31289 16.5939 8.30465 16.6113 8.299 16.6233C8.29618 16.6293 8.294 16.634 8.29248 16.6372C8.29171 16.6389 8.29111 16.6401 8.29068 16.6411C8.29046 16.6416 8.29028 16.6419 8.29015 16.6422C8.29008 16.6424 8.29001 16.6425 8.28997 16.6426C8.28991 16.6427 8.28986 16.6428 8.74358 16.8529ZM15.888 7.48039L15.6323 7.91009L20.971 11.0866L21.2267 10.6569L21.4824 10.2272L16.1437 7.0507L15.888 7.48039ZM21.2267 10.6569C20.7316 10.5872 20.7316 10.5871 20.7316 10.587C20.7316 10.587 20.7316 10.5869 20.7316 10.5869C20.7316 10.5868 20.7316 10.5869 20.7316 10.587C20.7316 10.5873 20.7315 10.5878 20.7314 10.5887C20.7311 10.5904 20.7307 10.5933 20.7301 10.5974C20.7289 10.6056 20.7269 10.6185 20.7241 10.6359C20.7186 10.6708 20.7098 10.7239 20.6974 10.7939C20.6724 10.9338 20.6327 11.1411 20.5742 11.4054C20.4571 11.934 20.2652 12.6894 19.9671 13.5876C19.3701 15.3862 18.3514 17.7458 16.665 20.0048L17.0657 20.3039L17.4663 20.603C19.2344 18.2346 20.2962 15.7707 20.9162 13.9026C21.2265 12.9675 21.4271 12.1787 21.5505 11.6216C21.6122 11.3429 21.6546 11.122 21.6818 10.9693C21.6954 10.893 21.7052 10.8337 21.7117 10.7928C21.715 10.7723 21.7174 10.7565 21.7191 10.7454C21.7199 10.7399 21.7205 10.7355 21.721 10.7323C21.7212 10.7308 21.7214 10.7295 21.7215 10.7285C21.7216 10.7281 21.7217 10.7276 21.7217 10.7273C21.7217 10.7272 21.7218 10.727 21.7218 10.7269C21.7218 10.7267 21.7218 10.7266 21.2267 10.6569ZM16.2806 7.63726L16.7439 7.82527L17.3327 6.37429L16.8694 6.18627L16.4061 5.99826L15.8173 7.44924L16.2806 7.63726ZM16.8694 6.18627C17.3501 6.32376 17.35 6.32416 17.3499 6.32456C17.3498 6.3247 17.3497 6.3251 17.3497 6.32536C17.3495 6.32588 17.3494 6.3264 17.3492 6.32692C17.3489 6.32795 17.3486 6.32895 17.3483 6.32994C17.3477 6.3319 17.3471 6.33378 17.3466 6.33558C17.3454 6.33917 17.3443 6.34245 17.3433 6.34546C17.3412 6.35144 17.3392 6.35651 17.3373 6.36088C17.3337 6.36928 17.3298 6.37674 17.3251 6.38385C17.3157 6.39813 17.2971 6.41958 17.2671 6.43357C17.1852 6.47173 17.2474 6.37023 17.6218 6.60823L17.89 6.18627L18.1583 5.76432C17.669 5.4533 17.2209 5.3518 16.8446 5.52722C16.6674 5.60983 16.5555 5.73422 16.4897 5.83429C16.4568 5.88429 16.4339 5.93035 16.4183 5.96663C16.4105 5.98494 16.4043 6.00127 16.3995 6.01502C16.397 6.02192 16.395 6.02822 16.3932 6.03385C16.3923 6.03667 16.3915 6.03933 16.3907 6.04182C16.3903 6.04307 16.39 6.04427 16.3896 6.04543C16.3895 6.04601 16.3893 6.04658 16.3891 6.04714C16.3891 6.04742 16.3889 6.04783 16.3889 6.04797C16.3888 6.04838 16.3887 6.04879 16.8694 6.18627ZM17.89 6.18627L17.6218 6.60823C18.0574 6.88517 18.9343 7.4265 19.6989 7.89653C20.0819 8.13201 20.4379 8.35029 20.6981 8.50969C20.8282 8.5894 20.9344 8.6544 21.0081 8.69947C21.0449 8.72201 21.0736 8.73957 21.0931 8.7515C21.1029 8.75746 21.1103 8.76202 21.1153 8.76508C21.1178 8.76662 21.1197 8.76778 21.121 8.76856C21.1216 8.76895 21.1221 8.76924 21.1224 8.76944C21.1226 8.76954 21.1227 8.76961 21.1228 8.76966C21.1229 8.76969 21.1229 8.7697 21.1229 8.76972C21.1229 8.76973 21.1229 8.76974 21.3837 8.34314C21.6445 7.91654 21.6445 7.91653 21.6445 7.91652C21.6445 7.91651 21.6444 7.91649 21.6444 7.91647C21.6443 7.91642 21.6442 7.91635 21.6441 7.91625C21.6437 7.91606 21.6433 7.91577 21.6426 7.91538C21.6414 7.91461 21.6395 7.91346 21.637 7.91193C21.632 7.90888 21.6246 7.90434 21.6149 7.8984C21.5954 7.8865 21.5668 7.86898 21.53 7.84648C21.4565 7.80149 21.3504 7.73658 21.2205 7.65697C20.9606 7.49775 20.605 7.27976 20.2226 7.04464C19.4562 6.5735 18.5863 6.0364 18.1583 5.76432L17.89 6.18627ZM21.3837 8.34314C21.1603 8.79044 21.1602 8.79037 21.16 8.79031C21.16 8.79029 21.1599 8.79023 21.1598 8.79019C21.1596 8.79011 21.1595 8.79004 21.1594 8.78997C21.1591 8.78984 21.1589 8.78974 21.1587 8.78965C21.1584 8.78949 21.1583 8.78942 21.1583 8.78944C21.1584 8.78948 21.1592 8.7899 21.1607 8.79068C21.1637 8.79224 21.1692 8.79522 21.1769 8.7995C21.1925 8.80814 21.2158 8.82167 21.2434 8.83928C21.3014 8.87635 21.3646 8.92292 21.4131 8.97138C21.4674 9.02567 21.4661 9.04507 21.4608 9.02307C21.4567 9.006 21.4548 8.97997 21.4617 8.95201C21.4683 8.9249 21.4783 8.9159 21.4708 8.92482L21.8548 9.2451L22.2387 9.56538C22.4326 9.33298 22.4978 9.05704 22.4328 8.78821C22.376 8.55297 22.2323 8.3763 22.1198 8.26392C22.0015 8.14571 21.8733 8.05503 21.7817 7.99651C21.7344 7.96632 21.6934 7.94248 21.6632 7.92569C21.6481 7.91725 21.6355 7.9105 21.626 7.90551C21.6212 7.90302 21.6172 7.90095 21.6141 7.89934C21.6125 7.89853 21.6111 7.89783 21.61 7.89725C21.6094 7.89696 21.6089 7.89669 21.6084 7.89646C21.6082 7.89634 21.6079 7.89623 21.6077 7.89612C21.6076 7.89607 21.6075 7.896 21.6074 7.89597C21.6073 7.8959 21.6072 7.89583 21.3837 8.34314ZM21.8548 9.2451L21.4708 8.92482C21.2696 9.16606 21.0401 9.45514 20.8625 9.68185C20.7734 9.79564 20.6967 9.89458 20.6421 9.96511C20.6149 10.0004 20.5932 10.0286 20.5782 10.048C20.5707 10.0578 20.565 10.0653 20.561 10.0704C20.5591 10.073 20.5575 10.075 20.5565 10.0763C20.556 10.077 20.5556 10.0775 20.5553 10.0779C20.5552 10.078 20.5551 10.0782 20.555 10.0783C20.555 10.0783 20.555 10.0784 20.5549 10.0784C20.5549 10.0784 20.5549 10.0784 20.5549 10.0784C20.5549 10.0784 20.5549 10.0784 20.9519 10.3824C21.349 10.6863 21.349 10.6863 21.3489 10.6863C21.349 10.6863 21.349 10.6863 21.349 10.6863C21.349 10.6863 21.349 10.6862 21.349 10.6862C21.3491 10.6861 21.3491 10.686 21.3493 10.6859C21.3495 10.6856 21.3498 10.6851 21.3503 10.6845C21.3512 10.6833 21.3526 10.6815 21.3545 10.6791C21.3582 10.6742 21.3638 10.667 21.371 10.6575C21.3855 10.6387 21.4067 10.6111 21.4334 10.5766C21.4869 10.5074 21.5622 10.4102 21.6498 10.2985C21.8254 10.0743 22.0474 9.79472 22.2387 9.56538L21.8548 9.2451ZM14.4356 8.77451L14.8827 8.55072L13.4303 5.64876L12.9831 5.87255L12.536 6.09634L13.9884 8.9983L14.4356 8.77451ZM12.9831 5.87255C13.4022 5.59986 13.4021 5.59965 13.402 5.59944C13.4019 5.59937 13.4018 5.59915 13.4017 5.599C13.4015 5.5987 13.4013 5.59839 13.401 5.59806C13.4006 5.59741 13.4002 5.5967 13.3997 5.59595C13.3987 5.59444 13.3975 5.59272 13.3962 5.59082C13.3937 5.58701 13.3905 5.58243 13.3868 5.57714C13.3794 5.5666 13.3697 5.55315 13.3578 5.53752C13.3342 5.50656 13.3007 5.46541 13.2581 5.42055C13.1784 5.33648 13.0415 5.21232 12.8538 5.13539C12.6496 5.05168 12.3862 5.0266 12.1166 5.15917C11.8677 5.28156 11.6764 5.50816 11.523 5.79109L11.9625 6.02941L12.402 6.26774C12.5038 6.08007 12.5676 6.05178 12.5579 6.05652C12.5276 6.07144 12.4874 6.06596 12.4746 6.06069C12.4738 6.06036 12.4802 6.06304 12.4931 6.07275C12.5056 6.08222 12.5192 6.09465 12.5327 6.10887C12.546 6.12283 12.5563 6.1356 12.5626 6.14385C12.5656 6.14783 12.5674 6.15031 12.5677 6.1508C12.5679 6.15103 12.5677 6.15073 12.5671 6.14984C12.5668 6.14939 12.5664 6.14878 12.5659 6.14802C12.5656 6.14764 12.5653 6.14722 12.565 6.14675C12.5649 6.14652 12.5647 6.14628 12.5646 6.14603C12.5645 6.1459 12.5643 6.1457 12.5643 6.14564C12.5642 6.14544 12.564 6.14524 12.9831 5.87255ZM11.9625 6.02941L11.523 5.79109C11.018 6.72234 10.0035 8.43767 9.60814 9.10905L10.039 9.36275L10.4699 9.61644C10.8596 8.95449 11.8863 7.21883 12.402 6.26774L11.9625 6.02941ZM10.039 9.36275L9.60814 9.10905C9.39837 9.4653 9.27362 9.81502 9.39015 10.1497C9.44602 10.3102 9.54201 10.414 9.58819 10.4627C9.65898 10.5372 9.61529 10.4961 9.59187 10.4493L10.039 10.2255L10.4861 10.0017C10.449 9.92762 10.4045 9.87301 10.3753 9.84C10.3523 9.8139 10.3154 9.77625 10.3132 9.77386C10.2906 9.75017 10.3179 9.77317 10.3345 9.82089C10.3534 9.87495 10.3411 9.90389 10.3479 9.87602C10.3565 9.84093 10.3851 9.76033 10.4699 9.61644L10.039 9.36275ZM10.039 10.2255L9.58065 10.4253L10.6405 12.8567L11.0989 12.6569L11.5572 12.4571L10.4973 10.0257L10.039 10.2255ZM20.7556 12.8922V13.3922H23.9353V12.8922V12.3922H20.7556V12.8922ZM23.9353 12.8922H24.4353C24.4353 13.1671 24.2313 13.2961 24.193 13.3188C24.1324 13.3547 24.0796 13.368 24.0633 13.3719C24.0229 13.3817 23.9946 13.3823 23.9918 13.3824C23.9787 13.3829 23.9805 13.3817 23.9943 13.3839C24.0258 13.389 24.0429 13.3989 24.0417 13.3981C24.0257 13.3863 24.0024 13.3534 24 13.3243C23.9995 13.3182 24.0062 13.3926 23.8961 13.5812L24.3279 13.8333L24.7596 14.0855C24.9243 13.8035 25.0193 13.52 24.9967 13.2431C24.9723 12.9431 24.8165 12.7264 24.6337 12.5921C24.4657 12.4687 24.2816 12.4174 24.1536 12.3967C24.0876 12.3861 24.0201 12.3809 23.9577 12.383C23.9302 12.384 23.8822 12.3869 23.8282 12.3999C23.8052 12.4055 23.7471 12.4206 23.683 12.4587C23.6411 12.4835 23.4353 12.6147 23.4353 12.8922H23.9353ZM24.3279 13.8333L23.8961 13.5812C23.358 14.5027 22.3983 16.1015 21.9718 16.8375L22.4044 17.0882L22.837 17.3389C23.274 16.5848 24.1986 15.0463 24.7596 14.0855L24.3279 13.8333ZM22.4044 17.0882L21.9718 16.8375C21.9198 16.9272 21.8782 16.9962 21.8446 17.0488C21.8104 17.1026 21.7885 17.1332 21.7761 17.1491C21.7701 17.1566 21.7691 17.1574 21.7725 17.1538C21.7755 17.1507 21.7873 17.1387 21.8076 17.1238C21.828 17.1089 21.8637 17.0861 21.9144 17.0686C21.9679 17.0501 22.0318 17.0399 22.1012 17.0462C22.1693 17.0524 22.2243 17.0728 22.2631 17.0925C22.2997 17.1111 22.324 17.1301 22.3332 17.1375C22.3419 17.1446 22.3471 17.1497 22.3403 17.1434C22.3369 17.1402 22.3227 17.1269 22.3078 17.1139C22.2752 17.0854 22.2179 17.0394 22.1371 17.0023C22.0527 16.9635 21.9576 16.9412 21.8548 16.9412V17.4412V17.9412C21.7464 17.9412 21.6704 17.8849 21.6508 17.8678C21.6503 17.8673 21.6495 17.8666 21.659 17.8754C21.6651 17.881 21.6826 17.8974 21.7035 17.9144C21.7409 17.9447 21.8482 18.0273 22.0108 18.0421C22.1858 18.058 22.3201 17.9879 22.398 17.9309C22.4706 17.8778 22.5252 17.8143 22.5628 17.7664C22.6399 17.6681 22.7287 17.5257 22.837 17.3389L22.4044 17.0882ZM21.8548 17.4412L21.815 16.9428L18.8708 17.1781L18.9107 17.6765L18.9505 18.1749L21.8946 17.9396L21.8548 17.4412ZM20.0098 0.5C19.6162 0.191654 19.6161 0.191756 19.616 0.191861C19.616 0.191901 19.6159 0.19201 19.6159 0.19209C19.6157 0.19225 19.6156 0.192423 19.6154 0.192611C19.6152 0.192987 19.6148 0.193419 19.6144 0.193907C19.6137 0.194882 19.6128 0.196081 19.6117 0.197501C19.6095 0.20034 19.6066 0.204061 19.6032 0.208637C19.5962 0.217787 19.5868 0.230372 19.5753 0.246169C19.5524 0.277731 19.5208 0.322301 19.4837 0.378078C19.4098 0.489181 19.3122 0.647159 19.2156 0.837356C19.0283 1.20625 18.8178 1.74875 18.8429 2.32566L19.3425 2.30392L19.842 2.28218C19.8278 1.95713 19.9511 1.59767 20.1072 1.29009C20.1824 1.14206 20.259 1.01817 20.3163 0.931971C20.3448 0.889096 20.3682 0.856153 20.3837 0.834867C20.3914 0.824239 20.3972 0.816565 20.4006 0.812062C20.4023 0.809812 20.4034 0.808359 20.4039 0.807729C20.4041 0.807414 20.4042 0.807306 20.4041 0.807408C20.4041 0.807459 20.404 0.807562 20.4039 0.807718C20.4038 0.807796 20.4038 0.807888 20.4037 0.807992C20.4036 0.808045 20.4036 0.808133 20.4035 0.808159C20.4035 0.808251 20.4034 0.808346 20.0098 0.5ZM19.3425 2.30392L18.8429 2.32566C18.8685 2.91411 19.106 3.31117 19.2995 3.60107C19.5136 3.92191 19.5809 4.01381 19.5894 4.14114L20.0883 4.10784L20.5872 4.07455C20.5564 3.61364 20.2705 3.25456 20.1313 3.04599C19.9714 2.80648 19.8556 2.5957 19.842 2.28218L19.3425 2.30392ZM20.0883 4.10784L19.5894 4.14114C19.6017 4.32455 19.5362 4.59412 19.4376 4.86131C19.3917 4.98582 19.3444 5.0947 19.3086 5.17224C19.2908 5.2108 19.2761 5.24107 19.2662 5.26103C19.2613 5.271 19.2576 5.27835 19.2553 5.28284C19.2541 5.28509 19.2534 5.28661 19.253 5.28739C19.2528 5.28778 19.2526 5.28798 19.2526 5.28798C19.2526 5.28799 19.2527 5.28794 19.2527 5.28785C19.2527 5.2878 19.2528 5.28774 19.2528 5.28767C19.2528 5.28764 19.2529 5.28757 19.2529 5.28756C19.2529 5.28749 19.2529 5.28742 19.6958 5.51961C20.1386 5.75179 20.1386 5.75172 20.1387 5.75164C20.1387 5.75161 20.1387 5.75153 20.1388 5.75147C20.1388 5.75135 20.1389 5.75121 20.139 5.75107C20.1391 5.75077 20.1393 5.75043 20.1395 5.75004C20.1399 5.74925 20.1404 5.74826 20.141 5.74707C20.1423 5.74469 20.1439 5.74152 20.1459 5.73759C20.1499 5.72973 20.1554 5.71882 20.1622 5.70512C20.1758 5.67774 20.1945 5.63908 20.2166 5.59124C20.2606 5.49598 20.3187 5.36222 20.3759 5.20732C20.4834 4.91568 20.6142 4.47937 20.5872 4.07455L20.0883 4.10784ZM22.4829 1.71569C22.0893 1.40734 22.0892 1.40744 22.0891 1.40755C22.0891 1.40759 22.089 1.4077 22.0889 1.40778C22.0888 1.40794 22.0887 1.40811 22.0885 1.4083C22.0882 1.40867 22.0879 1.40911 22.0875 1.40959C22.0868 1.41057 22.0858 1.41177 22.0847 1.41319C22.0825 1.41603 22.0797 1.41975 22.0762 1.42432C22.0693 1.43347 22.0599 1.44606 22.0484 1.46186C22.0254 1.49342 21.9939 1.53799 21.9568 1.59376C21.8829 1.70487 21.7852 1.86285 21.6887 2.05304C21.5014 2.42194 21.2909 2.96444 21.316 3.54135L21.8155 3.51961L22.3151 3.49787C22.3009 3.17281 22.4241 2.81336 22.5803 2.50578C22.6555 2.35774 22.732 2.23386 22.7894 2.14766C22.8179 2.10478 22.8413 2.07184 22.8568 2.05055C22.8645 2.03993 22.8702 2.03225 22.8737 2.02775C22.8754 2.0255 22.8765 2.02404 22.877 2.02342C22.8772 2.0231 22.8773 2.02299 22.8772 2.02309C22.8772 2.02314 22.8771 2.02325 22.877 2.0234C22.8769 2.02348 22.8768 2.02357 22.8768 2.02368C22.8767 2.02373 22.8766 2.02382 22.8766 2.02385C22.8765 2.02394 22.8765 2.02403 22.4829 1.71569ZM21.8155 3.51961L21.316 3.54135C21.3416 4.12979 21.5791 4.52686 21.7726 4.81676C21.9867 5.1376 22.054 5.2295 22.0625 5.35682L22.5614 5.32353L23.0603 5.29024C23.0295 4.82933 22.7435 4.47025 22.6044 4.26167C22.4445 4.02216 22.3287 3.81138 22.3151 3.49787L21.8155 3.51961ZM22.5614 5.32353L22.0625 5.35682C22.0747 5.54024 22.0092 5.80981 21.9107 6.07699C21.8648 6.20151 21.8175 6.31039 21.7817 6.38793C21.7639 6.42649 21.7492 6.45676 21.7393 6.47672C21.7344 6.48668 21.7307 6.49404 21.7284 6.49853C21.7272 6.50077 21.7264 6.5023 21.726 6.50308C21.7258 6.50346 21.7257 6.50366 21.7257 6.50367C21.7257 6.50367 21.7257 6.50363 21.7258 6.50353C21.7258 6.50349 21.7258 6.50343 21.7259 6.50336C21.7259 6.50332 21.7259 6.50326 21.7259 6.50324C21.726 6.50318 21.726 6.50311 22.1688 6.73529C22.6117 6.96748 22.6117 6.96741 22.6117 6.96733C22.6117 6.9673 22.6118 6.96722 22.6118 6.96716C22.6119 6.96703 22.612 6.9669 22.612 6.96675C22.6122 6.96646 22.6124 6.96612 22.6126 6.96572C22.613 6.96493 22.6135 6.96394 22.6141 6.96275C22.6153 6.96037 22.617 6.9572 22.619 6.95327C22.623 6.94542 22.6285 6.9345 22.6353 6.9208C22.6489 6.89343 22.6676 6.85476 22.6897 6.80693C22.7336 6.71167 22.7918 6.57791 22.8489 6.42301C22.9565 6.13137 23.0873 5.69506 23.0603 5.29024L22.5614 5.32353ZM10.4708 17.3627L10.9693 17.4011C11.0667 16.1372 12.1402 15.1569 13.4149 15.1569V14.6569V14.1569C11.6278 14.1569 10.1105 15.5295 9.97228 17.3244L10.4708 17.3627ZM13.4149 14.6569V15.1569C14.683 15.1569 15.8983 16.2794 15.8983 17.6373H16.3983H16.8983C16.8983 15.701 15.2088 14.1569 13.4149 14.1569V14.6569ZM16.3983 17.6373H15.8983C15.8983 18.0434 15.886 18.2991 15.8663 18.4639C15.846 18.6336 15.8224 18.6609 15.8323 18.6445C15.8471 18.62 15.8805 18.5987 15.7967 18.6627C15.7095 18.7294 15.5922 18.8268 15.4721 19.0068L15.888 19.2843L16.3039 19.5619C16.3408 19.5065 16.3659 19.4863 16.4038 19.4574C16.4451 19.4258 16.5865 19.331 16.6896 19.1594C16.7877 18.9959 16.8329 18.8027 16.8592 18.5827C16.8861 18.3577 16.8983 18.0546 16.8983 17.6373H16.3983Z" fill="#3E3E3E"/>
    </svg>`,
  },

  createNotification(message, options = {}) {
    if (!this.wrapper) {
      this.init();
    }

    // Vérifier le nombre de notifications actives
    const activeNotifications = this.wrapper.querySelectorAll("custom-notification");

    // Si on atteint la limite, supprimer la plus ancienne
    if (activeNotifications.length >= this.maxNotifications) {
      const oldest = activeNotifications[0];
      if (oldest) {
        oldest.hide();
        // Attendre un peu avant de retirer du DOM pour l'animation
        setTimeout(() => {
          if (oldest.parentNode) {
            oldest.remove();
          }
        }, 300);
      }
    }

    // Créer directement l'élément notification
    const notification = document.createElement("custom-notification");
    notification.className = "notification";

    // Choisir l'icône en fonction du type
    const iconType = options.type === "error" ? "error" : "success";
    const iconSvg = this.icons[iconType];

    // Créer le contenu HTML
    notification.innerHTML = `
      ${iconSvg}
      <div class="content">
        <p class="notification-text"></p>
      </div>
      <div class="progress-bar"></div>
    `;

    // Ajouter au wrapper
    this.wrapper.appendChild(notification);

    // Afficher la notification avec le message
    notification.show(message, options);

    // Écouter l'événement de fermeture pour retirer du DOM
    notification.addEventListener("notification-closed", () => {
      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 300);
    });

    return notification;
  },

  hideAll() {
    const notifications = this.wrapper.querySelectorAll("custom-notification");
    notifications.forEach((notif) => notif.hide());
  },
};

// Fonction helper globale pour la compatibilité avec le code existant
window.showNotification = function (message, options = {}) {
  return NotificationManager.createNotification(message, options);
};

// Fonction helper pour masquer toutes les notifications
window.hideNotification = function () {
  NotificationManager.hideAll();
};

/** Gestion des favoris */
// Favorites Manager
const Favorites = {
  storageKey: "wevan_market_favorites",

  // Get all favorites
  getAll() {
    const stored = localStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : [];
  },

  // Get favorites count
  getCount() {
    return this.getAll().length;
  },

  // Add a product to favorites
  add(productHandle) {
    const favorites = this.getAll();
    if (!favorites.includes(productHandle)) {
      favorites.push(productHandle);
      localStorage.setItem(this.storageKey, JSON.stringify(favorites));
    }
    return favorites;
  },

  // Remove a product from favorites
  remove(productHandle) {
    let favorites = this.getAll();
    favorites = favorites.filter((handle) => handle !== productHandle);
    localStorage.setItem(this.storageKey, JSON.stringify(favorites));
    return favorites;
  },

  // Check if product is favorited
  has(productHandle) {
    return this.getAll().includes(productHandle);
  },

  // Toggle favorite status
  toggle(productHandle) {
    return this.has(productHandle) ? this.remove(productHandle) : this.add(productHandle);
  },

  // Remove all favorites
  removeAll() {
    localStorage.setItem(this.storageKey, JSON.stringify([]));
    return [];
  },
};

// Update favorites link active state in header and all fav buttons
function updateFavoritesLinkState() {
  const favoriteHandles = Favorites.getAll();

  // Update header favorites link
  const headerIconFav = document.querySelector(".favorites_link");
  if (headerIconFav) {
    if (favoriteHandles.length > 0) {
      headerIconFav.classList.add("active");
    } else {
      headerIconFav.classList.remove("active");
    }
  }

  // Update all fav-button elements on the page
  const allFavButtons = document.querySelectorAll("fav-button");
  allFavButtons.forEach((favButton) => {
    const productHandle = favButton.dataset.productHandle;
    if (productHandle) {
      if (favoriteHandles.includes(productHandle)) {
        favButton.classList.add("selected");
      } else {
        favButton.classList.remove("selected");
      }
    }
  });
}

// Initialize favorites link state on page load
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", updateFavoritesLinkState);
} else {
  updateFavoritesLinkState();
}

/**
 * Text Truncate Web Component
 *
 * A custom element that truncates text to a specified number of lines
 * and shows a "Show more/Show less" button if content overflows.
 *
 * Responsive behavior:
 * - Mobile (≤769px): Truncates to specified mobile lines (default: 2)
 * - Desktop (>769px): Truncates to specified lines (default: 3)
 *
 * @attr {number} lines - Number of lines to display on desktop (default: 3)
 * @attr {number} mobile-lines - Number of lines to display on mobile (default: 2)
 * @attr {string} show-more - Text for "show more" button (default: "Voir plus")
 * @attr {string} show-less - Text for "show less" button (default: "Voir moins")
 *
 * @example
 * <text-truncate lines="5">
 *   <p>Your long text content here...</p>
 * </text-truncate>
 */
class TextTruncate extends HTMLElement {
  constructor() {
    super();
    this.expanded = false;
  }

  connectedCallback() {
    // Get attributes with defaults
    this.desktopLines = parseInt(this.getAttribute("lines")) || 3;
    this.mobileLines = parseInt(this.getAttribute("mobile-lines")) || 2; // Par défaut 2 lignes sur mobile
    this.showMoreText = this.getAttribute("show-more") || "Voir plus";
    this.showLessText = this.getAttribute("show-less") || "Voir moins";

    // Determine current lines based on screen size
    this.updateLinesForScreenSize();

    // Wrap content in a container
    const content = this.innerHTML;
    this.innerHTML = "";

    this.contentWrapper = document.createElement("div");
    this.contentWrapper.className = "text-truncate__content";
    this.contentWrapper.innerHTML = content;
    this.appendChild(this.contentWrapper);

    // Apply truncate styles
    this.applyTruncateStyles();

    // Check if content overflows after a small delay to ensure rendering is complete
    requestAnimationFrame(() => {
      if (this.isOverflowing()) {
        this.createToggleButton();
      }
    });

    // Listen to window resize to adjust lines on mobile/desktop switch
    this.handleResize = () => {
      const previousLines = this.lines;
      this.updateLinesForScreenSize();

      // Only update if lines changed and not expanded
      if (previousLines !== this.lines && !this.expanded) {
        this.applyTruncateStyles();
      }
    };
    window.addEventListener("resize", this.handleResize);
  }

  disconnectedCallback() {
    // Clean up event listener when component is removed
    if (this.handleResize) {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  updateLinesForScreenSize() {
    // Mobile breakpoint at 769px (consistent with your SCSS)
    const isMobile = window.innerWidth <= 769;
    this.lines = isMobile ? this.mobileLines : this.desktopLines;
  }

  applyTruncateStyles() {
    this.contentWrapper.style.overflow = "hidden";
    this.contentWrapper.style.textOverflow = "ellipsis";
    this.contentWrapper.style.display = "-webkit-box";
    this.contentWrapper.style.webkitLineClamp = this.lines.toString();
    this.contentWrapper.style.webkitBoxOrient = "vertical";
    this.contentWrapper.style.lineClamp = this.lines.toString();
  }

  removeTruncateStyles() {
    this.contentWrapper.style.overflow = "visible";
    this.contentWrapper.style.textOverflow = "clip";
    this.contentWrapper.style.display = "block";
    this.contentWrapper.style.webkitLineClamp = "none";
    this.contentWrapper.style.webkitBoxOrient = "horizontal";
    this.contentWrapper.style.lineClamp = "none";
  }

  isOverflowing() {
    // Simply check if content is truncated by comparing scrollHeight with clientHeight
    return this.contentWrapper.scrollHeight > this.contentWrapper.clientHeight;
  }

  createToggleButton() {
    this.toggleButton = document.createElement("p");
    this.toggleButton.className = "show_truncate";
    this.toggleButton.textContent = this.showMoreText;
    this.toggleButton.style.cursor = "pointer";
    this.toggleButton.setAttribute("data-state", "closed");

    this.toggleButton.addEventListener("click", () => this.toggle());
    this.appendChild(this.toggleButton);
  }

  /**
   * Recalcule le troncage.
   * Indispensable quand le composant est rendu dans un conteneur masqué
   * (une modal par exemple) : à la connexion, scrollHeight et clientHeight
   * valent 0, le débordement ne peut donc pas être détecté et le bouton
   * "Voir plus" n'est jamais créé.
   */
  refresh() {
    if (!this.contentWrapper || this.expanded) {
      return;
    }

    this.updateLinesForScreenSize();
    this.applyTruncateStyles();

    requestAnimationFrame(() => {
      if (!this.toggleButton && this.isOverflowing()) {
        this.createToggleButton();
      }
    });
  }

  toggle() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.removeTruncateStyles();
      this.toggleButton.textContent = this.showLessText;
      this.toggleButton.setAttribute("data-state", "open");
    } else {
      this.applyTruncateStyles();
      this.toggleButton.textContent = this.showMoreText;
      this.toggleButton.setAttribute("data-state", "closed");
    }
  }
}

// Register the custom element
customElements.define("text-truncate", TextTruncate);
